{
  "brand": {
    "name": "nextsub",
    "tagline": "像运营产品一样运营代理基础设施。"
  },
  "common": {
    "adminNote": {
      "label": "管理员备注",
      "hint": "仅管理员可见",
      "placeholder": "仅供运营参考,例如上游合同或成本"
    },
    "actions": {
      "add": "添加",
      "apply": "应用",
      "archive": "归档",
      "back": "返回",
      "cancel": "取消",
      "clear": "清除",
      "close": "关闭",
      "confirm": "确认",
      "continue": "继续",
      "copy": "复制",
      "copied": "已复制",
      "create": "创建",
      "delete": "删除",
      "disable": "停用",
      "done": "完成",
      "download": "下载",
      "edit": "编辑",
      "enable": "启用",
      "filter": "筛选",
      "format": "格式化",
      "hide": "隐藏",
      "loadMore": "加载更多",
      "manage": "管理",
      "more": "更多",
      "next": "下一步",
      "open": "打开",
      "previous": "上一步",
      "publish": "发布",
      "refresh": "刷新",
      "remove": "移除",
      "reset": "重置",
      "retry": "重试",
      "revoke": "撤销",
      "rotate": "轮换",
      "save": "保存",
      "saveChanges": "保存更改",
      "search": "搜索",
      "show": "显示",
      "signIn": "登录",
      "signOut": "退出登录",
      "skip": "稍后再说",
      "view": "查看",
      "viewAll": "查看全部",
      "clearSelection": "清除选择",
      "copyNamed": "复制{{name}}",
      "showNamed": "显示{{name}}",
      "hideNamed": "隐藏{{name}}",
      "dismiss": "关闭"
    },
    "labels": {
      "all": "全部",
      "any": "不限",
      "created": "创建时间",
      "description": "说明",
      "details": "详情",
      "email": "邮箱",
      "expires": "到期",
      "id": "ID",
      "lastSeen": "最后在线",
      "name": "名称",
      "never": "从未",
      "none": "无",
      "noExpiry": "长期有效",
      "optional": "可选",
      "status": "状态",
      "unknown": "未知",
      "unlimited": "不限量",
      "updated": "更新时间",
      "you": "你",
      "ip": "IP",
      "assigned": "分配时间",
      "unavailable": "暂不可用"
    },
    "time": {
      "justNow": "刚刚",
      "updatedAgo": "{{time}}更新"
    },
    "units": {
      "nodes_one": "{{count}} 个节点",
      "nodes_other": "{{count}} 个节点",
      "users_one": "{{count}} 位用户",
      "users_other": "{{count}} 位用户",
      "members_one": "{{count}} 个成员",
      "members_other": "{{count}} 个成员"
    },
    "search": {
      "placeholder": "搜索",
      "noResults": "没有匹配项",
      "optionsLabel": "搜索选项"
    },
    "copy": {
      "copied": "已复制到剪贴板",
      "failed": "复制失败，请手动选中文本复制。"
    },
    "unsaved": {
      "title": "放弃更改？",
      "body": "你的修改尚未保存。",
      "discard": "放弃",
      "keep": "继续编辑",
      "leave": "此面板有未保存的更改。离开页面并放弃这些更改？"
    },
    "typedConfirm": "输入 {{value}} 以确认",
    "loading": "正在加载…",
    "pending": "正在处理…",
    "showMore": "展开",
    "showLess": "收起",
    "rawData": "原始数据",
    "notAvailable": "不可用",
    "staleEdit": {
      "title": "内容已被他人修改",
      "body": "本次修改未保存。请关闭后重新打开，在最新版本上编辑。",
      "reload": "载入最新",
      "reloadBody": "你的修改未保存。请载入最新版本后重新修改。",
      "reloadFailed": "无法加载最新版本，你的编辑已保留。"
    },
    "inputs": {
      "unit": "单位",
      "rateNumerator": "倍率分子",
      "rateDenominator": "倍率分母",
      "quotaRequired": "请输入额度（0 或以上），或开启不限量。"
    },
    "secretGuard": {
      "leave": "一次性密钥正在签发或仍显示在屏幕上。现在离开将无法再次查看。仍要离开吗？"
    },
    "json": {
      "invalid": "这不是有效的 JSON。",
      "invalidAt": "这不是有效的 JSON（第 {{line}} 行，第 {{column}} 列）。",
      "editorLabel": "JSON 编辑器",
      "plainFallback": "完整编辑器无法加载（应用可能已更新）。你可以在这里继续编辑。"
    },
    "attempt": {
      "unresolvedTitle": "上一次提交可能已经成功",
      "unresolvedSame": "响应丢失了，无法确认是否已创建。用相同内容再次提交是安全的：会重放第一次提交，而不会再创建一个。",
      "unresolvedChanged": "你修改后的内容与上一次提交不同，而上一次可能已经创建成功，提交修改后的内容可能会再创建一个。请使用原内容安全重试，或者开始新的提交。",
      "maybeExistsTitle": "它很可能已经存在",
      "maybeExistsBody": "上一次提交很可能已经成功。再创建之前请先检查列表。它使用的信息保留在下方。",
      "retryOriginal": "使用原内容",
      "startNew": "开始新的提交",
      "expiredTitle": "之前的尝试已无法安全重试",
      "expiredBody": "它在一天多以前发出，现在重试可能会再执行一次。请先确认它是否已生效，需要时再新建一次。"
    },
    "confirmStale": "此内容在你打开后已被修改。请关闭此对话框，查看最新版本后重试。",
    "maybeDone": "操作可能已经生效",
    "maybeDoneBody": "响应丢失。页面数据已刷新，请先核对再重试。",
    "notApplied": "操作未生效",
    "notAppliedBody": "已重新检查：没有任何变化。可以重试。",
    "lastUnknown": "上一次重置的响应丢失，可能已经生效。确认将重试那一次（不会重复执行）。如果它显然已经生效（用量或链接已变化），请改为发起新的重置。",
    "startNewReset": "改为发起新的重置",
    "openRowHint": "按 Enter 或空格键打开。",
    "check": {
      "passed": "通过",
      "failed": "未通过",
      "notChecked": "未检查",
      "yes": "是",
      "no": "否"
    },
    "lastUnknownExpired": "上一次请求在一天多以前发出且结果未知，已无法安全重试。请先确认它是否已生效，需要时再新建一次。",
    "sort": {
      "ascending": "，升序",
      "descending": "，降序",
      "none": "，未排序"
    }
  },
  "errors": {
    "validationFailed": "部分字段需要修改。",
    "unauthorized": "登录已失效，请重新登录。",
    "forbidden": "你没有执行此操作的权限。",
    "notFound": "找不到该内容。",
    "conflict": "内容在你编辑期间已被修改，请重新加载后再试。",
    "idempotencyConflict": "此请求与之前的请求冲突。",
    "quotaExceeded": "此操作会超出允许的额度。",
    "rateLimited": "请求过于频繁，请稍后再试。",
    "readinessCheckFailed": "服务尚未就绪，请稍后再试。",
    "internalError": "服务端出现问题。",
    "networkError": "无法连接到服务器，请检查网络。",
    "requestFailed": "请求未成功。",
    "supportId": "支持编号：{{id}}",
    "retryIn": "{{seconds}} 秒后重试",
    "inProgress": "上一个请求仍在处理中，请稍后再试。",
    "staleTitle": "该内容已被他人修改",
    "staleBody": "重新加载以查看最新版本。离开页面前你的编辑会被保留。",
    "staleReload": "加载最新版本",
    "referencedBy": "仍被以下对象使用：",
    "analyticsUnavailable": "流量分析暂时不可用",
    "analyticsUnavailableBody": "用量与计费不受影响，图表恢复后会自动显示。",
    "loadFailed": "加载失败",
    "boundary": "此页面遇到了意外问题。",
    "boundaryAction": "重新加载",
    "references": {
      "subscriptions": "订阅",
      "subscription_package_snapshots": "订阅历史",
      "boot_sessions": "在线的适配器会话",
      "catalog_admin_node_selections": "租户节点选择",
      "global_node_group_members": "全局节点组",
      "tenant_node_group_members": "租户节点组",
      "subscription_link_nodes": "订阅链接",
      "subscription_package_snapshot_nodes": "订阅历史",
      "managed_users": "该管理员代管的用户",
      "tenant_distribution_packages": "租户分发套餐",
      "tenant_admin_role": "租户管理员角色",
      "node_agent_assignments": "仍在该服务器上的节点",
      "package_external_subscriptions": "套餐",
      "subscription_package_snapshot_external_subscriptions": "订阅历史",
      "user_roles": "角色",
      "user_management_assignments": "管理员分配",
      "user_credentials": "节点凭证",
      "traffic_routing_policies": "路由策略",
      "user_routing_policies": "路由策略",
      "billing_subscription_locks": "进行中的计费",
      "grants": "授权",
      "referenced_data": "相关记录",
      "nodes": "节点"
    },
    "conflictInUse": "该{{resource}}仍被以下内容使用：{{refs}}。",
    "conflictInUseAny": "仍被以下内容使用：{{refs}}。",
    "conflictResource": "该{{resource}}暂时无法修改。",
    "conflictGeneric": "与现有数据冲突。",
    "listSeparator": "、",
    "resources": {
      "node": "节点",
      "package": "套餐",
      "global_node_group": "节点组",
      "external_subscription": "外部订阅",
      "adapter_agent": "服务器",
      "user": "用户",
      "user_credential": "凭证"
    },
    "nameTaken": "该名称已被使用，请换一个。",
    "syncInProgress": "同步正在进行中，请在完成后重试。",
    "staleManifest": "服务器配置在此期间已变化。请重试，将使用最新版本。",
    "lastTenantAdmin": "这是该租户最后一位有效的管理员。请先将其他用户设为租户管理员，再停用或撤销此用户。",
    "packageNeedsRefresh": "该套餐的上游已变更。请先在“分发套餐”页刷新，再重新分配。",
    "reloadLoses": "重新加载会丢失此页保留的内容：结果未知的创建操作（及其生成的密码或信息）、未保存的修改或一次性密钥。仍要重新加载吗？"
  },
  "status": {
    "subscription": {
      "pending": "准备中",
      "pending_binding": "准备中",
      "active": "生效中",
      "paused": "已暂停",
      "cancelled": "已取消",
      "expired": "已过期",
      "exceeded": "已超额"
    },
    "node": {
      "pending": "待安装",
      "active": "已启用",
      "online": "在线",
      "offline": "离线",
      "draining": "排空中",
      "disabled": "已停用"
    },
    "package": {
      "draft": "草稿",
      "active": "已发布",
      "archived": "已归档",
      "needsRefresh": "需刷新"
    },
    "distributionMode": {
      "managed_only": "托管",
      "external_only": "外部",
      "mixed": "混合"
    },
    "link": {
      "active": "有效",
      "expired": "已过期",
      "revoked": "已撤销"
    },
    "token": {
      "active": "有效",
      "revoked": "已撤销",
      "expired": "已过期"
    },
    "user": {
      "active": "启用",
      "disabled": "已禁用"
    },
    "tenant": {
      "active": "启用",
      "disabled": "已停用"
    },
    "role": {
      "super_admin": "系统管理员",
      "tenant_admin": "用户管理员",
      "user": "成员"
    },
    "revokeMode": {
      "hard": "立即",
      "soft": "缓冲",
      "scheduled": "定时"
    },
    "grantOrigin": {
      "manual": "手动",
      "subscription": "订阅自动"
    },
    "announcement": {
      "draft": "草稿",
      "published": "已发布",
      "archived": "已归档",
      "expired": "已过期"
    },
    "policy": {
      "active": "已启用",
      "disabled": "已停用"
    },
    "policyScope": {
      "user": "全部节点",
      "user_node": "指定节点"
    },
    "routeMode": {
      "inherit": "继承",
      "overlay": "叠加",
      "replace": "替换"
    },
    "resource": {
      "active": "启用",
      "archived": "已归档"
    },
    "sync": {
      "never": "未同步",
      "success": "已同步",
      "error": "同步失败"
    },
    "syncError": {
      "fetch_failed": "无法拉取来源",
      "content_too_large": "来源内容过大",
      "invalid_source": "来源被拒绝（内容无效，或地址为内网）",
      "no_supported_nodes": "没有可用节点",
      "internal_error": "内部错误"
    },
    "inbound": {
      "ok": "正常",
      "stale": "已过期",
      "empty_initial_load": "尚无用户",
      "revision_conflict": "版本冲突",
      "unsupported_protocol": "协议不支持",
      "apply_failed": "应用失败"
    },
    "manifest": {
      "applied": "已应用",
      "pending": "待应用",
      "failed": "应用失败",
      "unknown": "尚未上报"
    },
    "preflight": {
      "passed": "预检通过",
      "failed": "预检未通过",
      "pending": "等待上报"
    },
    "outcome": {
      "success": "成功",
      "failure": "失败",
      "error": "错误",
      "denied": "已拒绝"
    },
    "capability": {
      "hysteria2": "支持",
      "anytls": "支持",
      "shadowsocks_unsupported": "不支持"
    },
    "credential": {
      "active": "有效",
      "expired": "已过期",
      "revoked": "已撤销",
      "not_yet_valid": "尚未生效"
    },
    "period": {
      "open": "进行中",
      "closed": "已结算"
    },
    "unknown": "未知"
  },
  "workspace": {
    "personal": "个人",
    "tenant": "用户管理",
    "operator": "管理控制台",
    "switcher": "工作区"
  },
  "nav": {
    "sections": {
      "connect": "连接",
      "account": "账户",
      "manage": "管理",
      "customers": "业务",
      "infrastructure": "基础设施",
      "access": "访问与信任",
      "system": "系统"
    },
    "home": "首页",
    "overview": "概览",
    "subscriptions": "订阅",
    "nodes": "节点",
    "usage": "用量",
    "notifications": "通知",
    "account": "账户",
    "users": "用户",
    "packages": "套餐",
    "distributionPackages": "分发套餐",
    "nodeGroups": "节点组",
    "tenants": "租户",
    "traffic": "流量",
    "servers": "服务器",
    "routing": "路由",
    "externalResources": "外部资源",
    "grants": "授权与封禁",
    "credentialDomains": "凭证域",
    "enrollmentTokens": "注册令牌",
    "announcements": "公告",
    "auditLogs": "审计日志"
  },
  "shell": {
    "search": "搜索",
    "searchHint": "搜索…",
    "notifications": "通知",
    "theme": "外观",
    "themeSystem": "跟随系统",
    "themeLight": "浅色",
    "themeDark": "深色",
    "language": "语言",
    "collapse": "收起侧栏",
    "expand": "展开侧栏",
    "openMenu": "打开菜单",
    "signedInAs": "当前登录",
    "accountSettings": "账户设置",
    "version": "版本 {{version}}",
    "webVersion": "Web {{version}}",
    "apiVersion": "API {{version}}",
    "skipToContent": "跳到正文",
    "signedInAsName": "当前登录：{{name}}",
    "signOutLosesTitle": "退出登录并丢弃未保存的内容？",
    "signOutLosesBody": "此页有内容会因退出登录而永久丢失：尚未保存的一次性密钥、未保存的修改，或结果未知的创建操作（及其生成的密码或信息）。"
  },
  "palette": {
    "placeholder": "搜索页面、用户、服务器…",
    "pages": "页面",
    "actions": "操作",
    "users": "用户",
    "tenants": "租户",
    "nodes": "节点",
    "servers": "服务器",
    "empty": "没有结果",
    "switchTo": "切换到{{workspace}}",
    "toggleTheme": "切换深色模式",
    "switchLanguage": "切换语言",
    "label": "命令菜单：搜索页面、人员和操作",
    "searchingAddresses": "正在查找服务器地址…",
    "addressLookupFailed": "无法查询服务器地址，未能按 IP 搜索服务器。",
    "searchFailed": "无法搜索{{what}}，结果可能不完整。",
    "searching": "正在搜索…"
  },
  "notifications": {
    "title": "通知",
    "empty": "没有新通知",
    "markAllRead": "全部标为已读",
    "markRead": "标为已读",
    "unread_one": "{{count}} 条未读",
    "unread_other": "{{count}} 条未读",
    "viewAll": "查看全部通知",
    "expires": "有效至 {{date}}",
    "unreadPrefix": "未读：",
    "markReadHint": "将这条通知标为已读。"
  },
  "auth": {
    "signInTitle": "NextSub 管理控制台",
    "email": "邮箱",
    "password": "密码",
    "emailInvalid": "请输入有效的邮箱地址。",
    "passwordRequired": "请输入密码。",
    "submit": "登录",
    "submitting": "正在登录…",
    "showPassword": "显示密码",
    "hidePassword": "隐藏密码",
    "sessionEnded": "你已退出登录，请重新登录以继续。",
    "invalidCredentials": "邮箱或密码不正确，请检查后重试。",
    "accountUnavailable": "密码正确，但无法打开此账号，可能已被停用。请联系管理员。"
  },
  "forbidden": {
    "title": "你无法访问此区域",
    "body": "你的账号没有此页面所需的角色。请切换工作区或返回首页。",
    "home": "返回首页"
  },
  "notFound": {
    "title": "页面不存在",
    "body": "链接可能已失效，或页面已移动。",
    "home": "返回首页"
  },
  "public": {
    "nav": {
      "product": "产品",
      "pricing": "定价",
      "signIn": "登录",
      "openConsole": "进入控制台"
    },
    "footer": {
      "privacy": "隐私政策",
      "terms": "服务条款",
      "pricing": "定价",
      "rights": "© {{year}} nextsub"
    },
    "landing": {
      "eyebrow": "代理控制面",
      "title": "你的代理机群。\n一个从容的控制台。",
      "primary": "登录",
      "secondary": "查看定价",
      "fleet": {
        "eyebrow": "基础设施",
        "title": "一条命令接入一台服务器。",
        "body": "每台服务器都会拿到一次性安装命令。节点把健康状态、配置版本和流量回报给面板，你始终知道实际在运行的是什么。",
        "points": ["Hysteria2、AnyTLS 与 Shadowsocks", "实时心跳与配置漂移检测", "路由先预检，再上线"]
      },
      "tenants": {
        "eyebrow": "分销",
        "title": "两级分销，边界清晰。",
        "body": "运营把套餐授予租户；租户在额度内重新打包给自己的用户，永远看不到边界之外。",
        "operator": "运营",
        "operatorBody": "服务器、套餐、授权",
        "tenant": "租户",
        "tenantBody": "用户、分发套餐",
        "user": "用户",
        "userBody": "一条链接，所有客户端"
      },
      "subscribe": {
        "eyebrow": "自助",
        "title": "扫码，导入，连接。",
        "body": "用户扫码或一键打开 Clash、sing-box、Shadowrocket。额度、用量和节点状态随时一眼可见。",
        "clients": "支持 Clash、sing-box、Shadowrocket，以及任何读取 URI 或 Base64 列表的客户端。"
      },
      "ledger": {
        "title": "每一份用量都可核对。",
        "body": "流量按节点以整数倍率计量，写入只追加的账本。更正以新记录呈现，绝不修改历史。"
      },
      "cta": {
        "title": "随时可以开始。",
        "body": "账号由你的服务商开通。",
        "action": "登录"
      },
      "mock": {
        "fleet": "机群",
        "online": "/ {{total}} 在线",
        "traffic": "流量 · 7 天",
        "packages": "套餐",
        "tenants": "租户",
        "users": "用户"
      }
    },
    "pricing": {
      "title": "定价",
      "popular": "最受欢迎",
      "perMonth": "/月",
      "start": "立即开始",
      "contact": "联系销售",
      "plans": [
        {
          "name": "专业版",
          "price": "$49",
          "description": "适合运营专注型机群的团队。",
          "features": ["最多 25 个节点", "租户数量不限", "流量分析与排行", "多凭证域", "注册令牌", "邮件支持"]
        },
        {
          "name": "企业版",
          "price": "定制",
          "description": "适合更大规模机群与分销商。",
          "features": ["节点与租户不限", "审计日志", "优先支持", "专属上线协助"]
        }
      ],
      "footnote": "价格不含税，预付计费。"
    },
    "legal": {
      "onThisPage": "本页内容"
    }
  },
  "rank": {
    "nodeBoard": "节点排行榜",
    "userBoard": "用户排行榜",
    "badge": "每日流量快照",
    "title": "流量排行榜",
    "reportDate": "{{date}} 报告",
    "generatedAt": "生成于 {{time}}（{{timezone}}）",
    "today": "当日总流量",
    "last30": "最近 30 天",
    "rawNote": "原始流量 · 不参与计费",
    "users": "用户",
    "nodes": "节点",
    "upload": "上行",
    "download": "下行",
    "empty": "当日没有流量记录。",
    "snapshotNote": "这是日报生成时保存的快照，不随实时数据变化，也不包含任何内部用户或节点标识。",
    "missing": {
      "title": "请从日报中打开",
      "body": "点击 Telegram 日报里的“查看完整排行榜”链接。"
    },
    "invalid": {
      "title": "排行榜链接无效",
      "body": "请确认复制了完整链接。"
    },
    "expired": {
      "title": "排行榜已过期",
      "body": "快照只保留一段时间。"
    },
    "failed": {
      "title": "无法加载排行榜"
    },
    "boardLabel": "排行榜"
  },
  "secret": {
    "onceBody": "请立即复制。出于安全考虑，这些内容不会再次显示。",
    "onceBanner": "仅显示一次。关闭前请妥善保存。",
    "expires": "{{date}} 过期",
    "savedConfirm": "我已妥善保存"
  },
  "charts": {
    "download": "下行",
    "upload": "上行",
    "total": "合计",
    "time": "时间",
    "tableCaption": "按小时的流量",
    "window": "时间范围",
    "windows": {
      "24h": "24 小时",
      "7d": "7 天",
      "30d": "30 天",
      "90d": "90 天"
    },
    "quotaUsage": "已用 {{percent}}：{{used}} / {{quota}}",
    "unlimitedUsage": "已用 {{used}}，不限量",
    "updated": "{{time}}更新",
    "noTraffic": "该时段没有流量",
    "staleFailed": "刷新失败，显示的是之前的数据",
    "staleUnavailable": "流量分析暂不可用，显示的是之前的数据"
  },
  "me": {
    "home": {
      "morning": "早上好，{{name}}",
      "afternoon": "下午好，{{name}}",
      "evening": "晚上好，{{name}}",
      "quota": "本周期",
      "of": "共 {{quota}}",
      "noQuota": "不限流量",
      "periodLabel": "周期 {{period}}",
      "nearLimit": "本周期流量已用掉大半。",
      "overQuota": "本周期流量已用完，连接已暂停，重置后恢复。",
      "resetTraffic": "重置用量",
      "resetTitle": "重置本周期用量？",
      "resetBody": "当前周期的已用流量将归零。",
      "resetConsequences": ["历史用量记录会保留。", "需套餐允许重置，操作不可撤销。"],
      "resetDone": "用量已重置",
      "import": "快速导入",
      "noSubscription": "还没有套餐或导入链接",
      "noSubscriptionBody": "管理员尚未为此账号分配套餐或签发导入链接。完成后会自动显示在这里。",
      "nodes": "节点",
      "nodesOnline": "{{online}} / {{total}} 在线",
      "noNodes": "暂无可用节点",
      "traffic": "最近 24 小时",
      "latest": "最新",
      "noNotifications": "暂无公告",
      "used": "已用",
      "linkInactive": "此链接已无法在应用中使用，请联系管理员获取新链接。",
      "noActiveLink": "你的套餐当前没有可用的导入链接。请联系管理员签发。"
    },
    "subscriptions": {
      "title": "订阅",
      "defaultName": "我的订阅",
      "scan": "扫码导入",
      "scanHint": "在 Shadowrocket 中打开",
      "copyLink": "复制链接",
      "linkLabel": "订阅链接",
      "customize": "更多选项",
      "customizeTitle": "自定义链接",
      "customizeBody": "为有特殊需求的客户端选择格式和地址类型。",
      "format": "格式",
      "formats": {
        "auto": "自动",
        "clash": "Clash",
        "singbox": "sing-box",
        "uri": "URI 列表",
        "base64": "Base64"
      },
      "formatHints": {
        "auto": "服务端根据客户端自动选择格式。",
        "clash": "适用于 Clash 及兼容应用的 YAML 配置。",
        "singbox": "完整的 sing-box 客户端配置。",
        "uri": "每个节点一条分享链接。",
        "base64": "适用于 v2rayN、Quantumult 等。"
      },
      "family": "地址",
      "families": {
        "v4": "IPv4",
        "v6": "IPv6",
        "v4v6": "双栈"
      },
      "external": "外部节点",
      "externals": {
        "managed": "不包含",
        "mixed": "包含",
        "only": "仅外部"
      },
      "nodeCount_one": "{{count}} 个节点",
      "nodeCount_other": "{{count}} 个节点",
      "expires": "{{date}} 到期",
      "noExpiry": "长期有效",
      "resetTitle": "重置订阅",
      "resetBody": "如果链接泄露或想让旧设备失效，可以生成新链接。所有使用旧链接的客户端都会停止工作。",
      "resetAction": "重置订阅",
      "resetConfirmTitle": "重置你的订阅？",
      "resetConfirmBody": "将立即生成新的链接。",
      "resetConsequences": ["当前链接会立即失效。", "需要在每台设备上重新导入新链接。"],
      "resetDone": "订阅已重置，请在设备上导入新链接。",
      "empty": "没有可用的导入链接",
      "emptyBody": "请联系管理员为你的账号分配套餐或签发导入链接。",
      "singBoxUnsupported": "sing-box 支持受管 Hysteria2、AnyTLS 和 Shadowsocks 节点，当前套餐含有暂不支持的节点。",
      "singBoxUnchecked": "节点列表加载完成前无法使用 sing-box。",
      "linksUnconfirmed": "最近的更改可能已替换这些链接，在加载到最新内容前将暂时隐藏（可能需要几秒）。",
      "reloadLinks": "重新加载链接",
      "qrTooLong": "该链接过长，无法生成二维码。请复制链接或使用导入按钮。",
      "singBoxNoNodes": "当前没有可用节点，暂时无法导入 sing-box，有节点后即可使用。",
      "singBoxChecking": "正在检查你的套餐能否导入 sing-box…"
    },
    "nodes": {
      "title": "节点",
      "online": "在线",
      "offline": "离线",
      "lastSeen": "{{time}}在线",
      "neverSeen": "尚未上线",
      "empty": "暂无可用节点",
      "emptyBody": "套餐包含节点后会显示在这里。",
      "refreshing": "每 30 秒自动刷新"
    },
    "usage": {
      "title": "用量",
      "trend": "趋势",
      "byNode": "按节点",
      "topNode": "用量最多",
      "windowTotal": "区间合计",
      "noNodeTraffic": "该时段没有节点流量。",
      "usedLabel": "本周期已用",
      "quotaLabel": "配额",
      "periodLabel": "计费周期",
      "viewLabel": "用量视图",
      "windowTotalTop": "前 {{count}} 个节点合计",
      "rankCapped": "仅显示用量最高的 {{count}} 个节点，合计与占比只统计这些节点；完整总量请看趋势视图。",
      "nodesWithTraffic": "有流量的节点"
    },
    "notifications": {
      "truncatedTitle": "仅显示最新的通知",
      "truncatedBody": "只列出最新的 {{count}} 条。更早的未读通知仍计入未读数，“全部标为已读”也会一并清除。"
    },
    "settings": {
      "title": "账户",
      "tabs": {
        "profile": "资料",
        "security": "安全",
        "appearance": "外观",
        "credentials": "凭证"
      },
      "displayName": "昵称",
      "email": "邮箱",
      "userId": "用户 ID",
      "role": "角色",
      "saveNickname": "保存昵称",
      "nicknameSaved": "昵称已保存",
      "currentPassword": "当前密码",
      "newPassword": "新密码",
      "confirmPassword": "确认新密码",
      "passwordMin": "至少 12 个字符。",
      "passwordMismatch": "两次输入的密码不一致。",
      "passwordRequired": "请输入当前密码。",
      "changePassword": "修改密码",
      "signOutNote": "修改密码后将退出登录，请使用新密码重新登录。",
      "passwordChanged": "密码已修改，请使用新密码登录。",
      "theme": "外观",
      "language": "语言",
      "domain": "凭证域",
      "version": "版本",
      "validFrom": "生效时间",
      "validUntil": "失效时间",
      "noCredentials": "还没有凭证",
      "noCredentialsBody": "分配套餐后会自动创建凭证。",
      "currentPasswordWrong": "当前密码不正确。",
      "passwordMaybeChanged": "新密码可能已经生效",
      "passwordMaybeChangedBody": "连接中断，但会话已被注销（修改密码后会发生这种情况）。请用新密码登录；若失败，再用旧密码。",
      "domainN": "凭证域 {{n}}",
      "passwordSessionChanged": "无法确认密码是否已修改",
      "passwordSessionChangedBody": "发送期间你在另一个标签页登录或退出了，修改可能已生效，也可能没有。请先用新密码登录；若失败，请使用旧密码。",
      "changeLosesTitle": "修改密码并丢弃未保存的内容？",
      "changeLosesBody": "修改密码会退出登录。此标签页保留了结果未知的创建操作（及其生成的密码或信息），退出后将永久丢失。",
      "changeAnyway": "修改密码",
      "passwordUnknown": "无法确认密码是否已修改",
      "passwordUnknownBody": "连接中断且确认也失败了，修改可能已经生效。你已被登出：请先用新密码登录；若失败，请使用旧密码。",
      "passwordUnconfirmed": "无法确认密码是否已修改",
      "passwordUnconfirmedBody": "响应丢失，你仍处于登录状态，修改可能尚未生效。请不要立即重试：如果稍后被登出，请用新密码登录；否则请一分钟后再试。",
      "passwordHeld": "上一次修改可能已经生效。如果你被登出，请用新密码登录；否则请等待一分钟后再试。",
      "passwordTryAgain": "重试"
    }
  },
  "users": {
    "title": "用户",
    "new": "新建用户",
    "search": "搜索名称或邮箱",
    "columns": {
      "user": "用户",
      "status": "状态",
      "plan": "套餐与用量",
      "expires": "到期",
      "manager": "管理员",
      "tenant": "租户",
      "role": "角色"
    },
    "noPlan": "未分配套餐",
    "direct": "平台直管",
    "empty": "还没有用户",
    "emptyBody": "创建第一个账号，并可同时为其分配套餐。",
    "noMatch": "没有符合筛选条件的用户",
    "filters": {
      "status": "状态",
      "role": "角色",
      "tenant": "租户",
      "ownership": "归属",
      "direct": "平台直管",
      "managedBy": "由…代管",
      "managedByName": "由 {{name}} 代管",
      "clearManager": "清除管理员筛选",
      "selectedAdmin": "所选管理员"
    },
    "create": {
      "title": "新建用户",
      "email": "邮箱",
      "displayName": "名称",
      "password": "密码",
      "passwordHint": "至少 12 个字符。创建后只显示一次。",
      "generate": "生成",
      "plan": "套餐",
      "planHint": "可选，立即为其开通订阅。",
      "noPlan": "暂不分配",
      "tenant": "租户",
      "submit": "创建用户",
      "created": "用户已创建",
      "secretTitle": "账号已创建",
      "secretBody": "请安全地交给对方。之后你无法再查看此密码。",
      "planFailed": "用户已创建，但套餐分配失败，请重新分配。",
      "planMaybe": "用户已创建，但套餐可能未分配成功。请重试确认；已分配的套餐不会重复分配。",
      "retryPlan": "重试分配",
      "planAssigned": "套餐已分配",
      "maybeCreatedTitle": "该账号可能已创建",
      "maybeCreatedSame": "上次提交没有收到响应，账号可能已创建。用相同信息再次创建会完成那次提交并显示登录信息。",
      "maybeCreatedChanged": "上次提交没有收到响应，那个账号可能已存在。当前信息与其不同，请先查看用户列表再创建新账号。",
      "displayNameTooLong": "最多 255 个字符。",
      "planSince": "该用户现在已有套餐（期间被分配）。如需更换，请使用“分配套餐”，它会先显示当前套餐。"
    },
    "edit": {
      "title": "编辑用户",
      "newPassword": "新密码",
      "newPasswordHint": "留空则保持当前密码。",
      "saved": "已保存",
      "emailTaken": "已有账号使用此邮箱。",
      "ownPasswordHint": "这是你自己的账户。请在“设置 → 安全”中修改密码；在此修改会使你立即退出登录。"
    },
    "actions": {
      "edit": "编辑",
      "enable": "启用",
      "disable": "禁用",
      "delete": "删除用户",
      "assign": "分配套餐",
      "copyLink": "复制订阅链接",
      "copyPassword": "复制节点密码",
      "resetTraffic": "重置用量",
      "resetSubscription": "重置订阅",
      "open": "查看详情"
    },
    "enabled": "用户已启用",
    "disabled": "用户已禁用",
    "deleted": "用户已删除",
    "deleteTitle": "删除 {{name}}？",
    "deleteBody": "将永久删除该账号并取消其订阅。",
    "deleteConsequences": [
      "登录、角色、凭证、路由与订阅链接都会被删除。",
      "账单与审计记录会匿名保留。",
      "此操作不可撤销。"
    ],
    "disableTitle": "禁用 {{name}}？",
    "disableBody": "该用户将被登出且无法登录。其导入链接、连接凭证和基于套餐的节点访问会立即被撤销。之后重新启用账号只会恢复登录：需重置其订阅以生成新的导入链接。",
    "detail": {
      "tabs": {
        "overview": "概览",
        "access": "访问",
        "plan": "套餐",
        "links": "链接"
      },
      "joined": "{{date}} 加入",
      "noAccess": "没有生效的订阅",
      "noAccessBody": "为该用户分配套餐后即可访问。",
      "importLinks": "导入链接",
      "passwords": "节点密码",
      "passwordKinds": {
        "node": "节点密码",
        "shadowsocks": "Shadowsocks 密码"
      },
      "currentPlan": "当前套餐",
      "period": "周期 {{start}} – {{end}}",
      "usage": "本周期用量",
      "resetNeedsActive": "启用该账号后才能重置用量或订阅。",
      "linkInactive": "此链接已失效。请在“订阅”中签发新链接。",
      "accessUnconfirmed": "最近对该用户的更改可能已替换这些链接和密码，在加载到最新内容前将暂时隐藏（可能需要几秒）。",
      "reloadAccess": "重新加载访问信息",
      "planUnconfirmed": "最近对该用户的更改可能已替换其套餐，在加载到最新内容前将暂时隐藏（且无法分配）。",
      "noActiveLink": "没有可用的导入链接。重置订阅即可签发新链接。",
      "noPassword": "该用户当前没有可复制的密码。"
    },
    "resetTrafficTitle": "重置 {{name}} 的用量？",
    "resetTrafficBody": "当前周期用量将归零，历史记录保留。",
    "resetTrafficDone": "用量已重置",
    "resetSubTitle": "重置 {{name}} 的订阅？",
    "resetSubBody": "将立即生成新的链接和节点密码。",
    "resetSubConsequences": ["旧链接与旧密码立即失效。", "用户需要在每台设备上重新导入。"],
    "resetSubDone": "订阅已重置",
    "planUnavailable": "暂不可用",
    "plansFailed": "套餐信息加载失败，套餐与到期列不完整。",
    "copyPasswordSeveral": "该用户有多个凭证",
    "copyPasswordSeveralBody": "请在其“访问”页中复制所需的那一个。",
    "openGone": "该用户已不存在"
  },
  "assign": {
    "title": "分配套餐",
    "description": "用户原有的链接和密码保持不变，只更新节点。",
    "plan": "套餐",
    "user": "用户",
    "label": "链接标签",
    "labelHint": "可选，用于区分不同链接。",
    "submit": "分配",
    "noPlans": "暂无可分配的已发布套餐",
    "secretTitle": "套餐已分配",
    "secretBody": "将此导入链接发给用户。之后也可随时在其“访问”标签中再次查看。",
    "link": "导入链接",
    "secret": "链接密钥",
    "loadingLink": "正在获取导入链接…",
    "linkMissing": "新链接暂未出现，请稍后在该用户的访问页签中复制。",
    "replaces": "当前套餐：{{plan}}。分配新套餐会立即替换它。",
    "replaceTitle": "替换当前套餐？",
    "replaceBody": "{{plan}} 将立即结束（包括当前周期与额度），新套餐随即生效。用户的导入链接会保留并切换到新套餐。",
    "labelKeptLinks": "该用户已有导入链接，会被保留，因此不会使用标签。",
    "planChanged": "打开此窗口后，该用户的套餐已变更。请确认后重新分配。"
  },
  "tenantHome": {
    "title": "概览",
    "users": "用户",
    "activeUsers": "{{count}} 位启用",
    "subscriptions": "订阅",
    "exceeded": "{{count}} 个超额",
    "expiring": "{{count}} 个将在 7 天内到期",
    "allocation": "你的额度",
    "noAllocation": "尚无额度",
    "noAllocationBody": "请联系运营为你分配包含节点的套餐。",
    "maxQuota": "每个套餐最多 {{quota}}",
    "traffic": "流量 · 7 天",
    "topUsers": "用量最高的用户",
    "attention": "需要关注",
    "allGood": "一切正常",
    "attentionItems": {
      "exceeded": "超额的订阅",
      "refresh": "需要刷新的套餐",
      "disabledLinks": "已禁用但仍有有效链接的用户"
    },
    "quick": {
      "newUser": "新建用户",
      "newSubscription": "分配套餐"
    },
    "allocationNodes_other": "{{count}} 个可分发节点",
    "allocationNodes_one": "{{count}} 个可分发节点"
  },
  "dpackages": {
    "title": "分发套餐",
    "new": "新建套餐",
    "allocation": "额度",
    "allocationBody": "来自 {{package}}：{{nodes}} 个节点，每个套餐最多 {{quota}}。",
    "unlimitedQuota": "不限流量",
    "noAllocation": "你还没有额度",
    "noAllocationBody": "请联系运营为你分配包含节点的套餐，之后即可在这里创建分发套餐。",
    "empty": "还没有分发套餐",
    "emptyBody": "创建套餐、选择节点与额度，发布后即可分配给用户。",
    "nodes_one": "{{count}} 个节点",
    "nodes_other": "{{count}} 个节点",
    "updated": "{{time}}更新",
    "needsRefresh": "你的额度已变化。编辑并保存此套餐以移除不再可用的节点。",
    "editor": {
      "createTitle": "新建分发套餐",
      "editTitle": "编辑分发套餐",
      "name": "名称",
      "description": "说明",
      "quota": "每周期流量",
      "quotaMax": "不能超过你的额度 {{quota}}。",
      "quotaTooHigh": "超出了你的额度上限。",
      "resetEnabled": "允许用户自助重置用量",
      "resetHint": "用户在接近上限时可自行重置用量。",
      "resetUnavailable": "你的额度不允许自助重置。",
      "nodes": "节点",
      "nodesRequired": "至少选择一个节点。",
      "selectAll": "全选",
      "selectNone": "清空",
      "unavailable_one": "之前选中的 {{count}} 个节点已不可用，保存后会被移除。",
      "unavailable_other": "之前选中的 {{count}} 个节点已不可用，保存后会被移除。",
      "saved": "套餐已保存",
      "created": "套餐已创建为草稿",
      "allocationStale": "无法刷新你的分配，其节点列表可能已过期。重新加载前无法保存。",
      "nodesGone": "你选择的节点已不在你的分配中，请至少选择一个可用节点。",
      "nodesLeft_one": "有 {{count}} 个已选节点不再属于你的分配，请检查节点后重新保存。",
      "nodesLeft_other": "有 {{count}} 个已选节点不再属于你的分配，请检查节点后重新保存。",
      "quotaCapChanged": "你的分配额度已变更，此套餐的额度已超出上限，请检查额度后重新保存。",
      "resetChanged": "上游额度的流量重置规则已变更。请确认后再保存。"
    },
    "actions": {
      "publish": "发布",
      "apply": "应用到现有用户",
      "archive": "归档",
      "delete": "删除",
      "edit": "编辑"
    },
    "published": "套餐已发布",
    "applied": "更改已应用到现有用户",
    "archived": "套餐已归档",
    "deleted": "套餐已删除",
    "publishTitle": "发布 {{name}}？",
    "publishBody": "发布后即可分配给用户。",
    "applyTitle": "将更改应用到现有用户？",
    "applyBody": "所有使用 {{name}} 的用户都会获得更新后的节点、凭证与订阅内容。",
    "applyConsequences": ["用户链接不变，节点列表会在下次刷新时更新。", "在编辑已发布的套餐后执行此操作。"],
    "archiveTitle": "归档 {{name}}？",
    "archiveBody": "现有订阅继续使用，但不能再分配给新用户。",
    "deleteTitle": "删除 {{name}}？",
    "deleteBody": "只有未被任何生效订阅使用的套餐才能删除。如仍在使用，请改为归档。",
    "gone": "该分发套餐已不存在"
  },
  "tsubs": {
    "title": "订阅",
    "tabs": {
      "subscriptions": "订阅",
      "links": "链接"
    },
    "new": "分配套餐",
    "columns": {
      "user": "用户",
      "plan": "套餐",
      "status": "状态",
      "usage": "用量",
      "period": "周期",
      "link": "链接"
    },
    "empty": "还没有订阅",
    "emptyBody": "为用户分配套餐即可创建第一个订阅。",
    "links": {
      "new": "新建链接",
      "columns": {
        "label": "标签",
        "user": "所属订阅",
        "status": "状态",
        "created": "创建时间",
        "expires": "到期"
      },
      "empty": "还没有链接",
      "emptyBody": "每个订阅会自动生成一条链接。可为不同设备额外创建链接。",
      "createTitle": "新建链接",
      "createBody": "为已有订阅额外签发一条导入链接。",
      "subscription": "订阅",
      "label": "标签",
      "expires": "到期时间",
      "expiresHint": "可选。到期后链接失效。",
      "editTitle": "编辑链接",
      "status": "状态",
      "secretTitle": "链接已就绪",
      "rotatedTitle": "密钥已轮换",
      "rotatedBody": "旧链接已失效，请在用户的“访问”标签中复制新链接发给对方。",
      "rotateTitle": "轮换 {{name}} 的密钥？",
      "rotateBody": "当前链接会立即失效，并签发新链接。",
      "revokeTitle": "删除 {{name}}？",
      "revokeBody": "该链接会立即失效且无法恢复。",
      "rotate": "轮换密钥",
      "revoke": "删除链接",
      "deleted": "链接已删除",
      "saved": "链接已更新",
      "unnamed": "未命名链接",
      "createdBody": "新链接已就绪，可在用户的“访问”标签中复制。",
      "created": "链接已创建",
      "expiryCannotClear": "到期时间设置后无法移除，请改为更晚的日期。",
      "expireTitle": "将 {{name}} 设为过期？",
      "expireBody": "保存后，所有使用此链接的设备都会立即断开。之后可以重新设为有效。",
      "expireConfirm": "设为过期",
      "thisLink": "此链接",
      "subsUnavailable": "无法加载订阅",
      "subsUnavailableBody": "加载完成前无法显示所属用户，也无法新建链接。",
      "expiryMustBeFuture": "该链接已过期。请设置一个未来的到期时间以重新启用。",
      "maybeDone": "操作可能已经生效",
      "maybeDoneBody": "响应丢失。链接列表已刷新，请先核对再重试。"
    }
  },
  "tgroups": {
    "title": "节点组",
    "new": "新建节点组",
    "name": "组名称",
    "empty": "还没有节点组",
    "emptyBody": "把节点分组以便管理。",
    "manage": "选择节点",
    "manageTitle": "{{name}} 中的节点",
    "manageBody": "从运营授权给你的节点中选择。保存后将替换该组的全部节点。",
    "noNodes": "运营尚未向你授权任何节点。",
    "saved": "节点已更新",
    "created": "节点组已创建",
    "deleted": "节点组已删除",
    "deleteTitle": "删除 {{name}}？",
    "deleteBody": "节点组及其节点选择将被删除，且不可撤销。",
    "members_one": "{{count}} 个节点",
    "members_other": "{{count}} 个节点",
    "unavailableTitle_one": "{{count}} 个成员已不可用",
    "unavailableTitle_other": "{{count}} 个成员已不可用",
    "unavailableBody": "它们的授权已撤销或已被封禁。保存后将从本组移除。",
    "nodesUnavailable": "无法加载节点名称",
    "nodesUnavailableBody": "节点列表加载前，成员将不显示名称。",
    "unknownNode": "未知节点",
    "nodesLeft_one": "有 {{count}} 个已选节点已不再可用，请检查列表后重新保存。",
    "nodesLeft_other": "有 {{count}} 个已选节点已不再可用，请检查列表后重新保存。"
  },
  "tusage": {
    "title": "用量",
    "tabs": {
      "traffic": "流量",
      "billable": "计费用量"
    },
    "topUsers": "用量最高的用户",
    "topNodes": "用量最高的节点",
    "columns": {
      "subscription": "订阅",
      "meter": "计量项",
      "total": "合计",
      "window": "计量区间",
      "updated": "更新时间"
    },
    "filters": {
      "subscription": "订阅",
      "period": "周期"
    },
    "empty": "还没有用量记录",
    "emptyBody": "用户开始连接后会显示用量。",
    "meters": {
      "adapter_traffic": "数据流量",
      "other": "其他计量（{{name}}）"
    },
    "subsFailed": "订阅加载失败。无法将记录对应到用户，订阅筛选暂不可用。"
  },
  "opHome": {
    "title": "概览",
    "userCount": "用户总数",
    "monthlyTraffic": "本月累计流量",
    "fleet": "机群",
    "nodesOnline": "{{online}} / {{total}} 个节点在线",
    "serversOnline": "{{online}} / {{total}} 台服务器在线",
    "online": "在线",
    "attentionNodes": "需关注",
    "offline": "离线",
    "attention": "需要关注",
    "attentionItems": {
      "pendingServers": "等待安装的服务器",
      "applyFailed": "配置应用失败的服务器",
      "driftNodes": "配置漂移的节点",
      "offlineNodes": "已启用但离线的节点",
      "refreshPackages": "需要刷新的套餐",
      "syncErrors": "同步失败的外部订阅"
    },
    "traffic": "流量 · 7 天",
    "topTenants": "流量最高的租户",
    "recentActivity": "最近活动",
    "noActivity": "暂无最近活动",
    "announcements": "公告",
    "publishedCount_one": "{{count}} 条已发布",
    "publishedCount_other": "{{count}} 条已发布",
    "newAnnouncement": "新建公告",
    "customers": "客户",
    "tenantsCount_one": "{{count}} 个租户",
    "tenantsCount_other": "{{count}} 个租户",
    "announcementsUnavailable": "公告暂不可用",
    "noActivityScanned": "最近 {{count}} 条日志中没有操作记录，打开审计日志查看更早的记录。",
    "topUsers": "排行榜"
  },
  "tenants": {
    "title": "租户",
    "new": "新建租户",
    "search": "搜索名称或 slug",
    "columns": {
      "tenant": "租户",
      "status": "状态",
      "created": "创建时间"
    },
    "empty": "还没有租户",
    "emptyBody": "开通租户，为分销商提供独立空间与管理员账号。",
    "wizard": {
      "title": "新建租户",
      "steps": ["租户", "管理员", "确认"],
      "name": "租户名称",
      "slug": "URL 标识",
      "slugHint": "小写字母、数字和连字符。",
      "slugInvalid": "只能使用小写字母、数字和连字符。",
      "adminEmail": "管理员邮箱",
      "adminName": "管理员名称",
      "adminPassword": "管理员密码",
      "review": "创建前请确认信息。租户与其第一位管理员会一起创建。",
      "submit": "创建租户",
      "secretTitle": "租户已创建",
      "secretBody": "请将以下登录信息交给租户管理员。",
      "maybeCreatedTitle": "该租户可能已创建",
      "maybeCreatedBody": "上次提交没有收到响应。用相同信息再次提交会完成那次创建并显示管理员登录信息；修改信息则会创建新租户。",
      "slugNeeded": "请填写 URL 标识：无法从该名称自动生成。",
      "emailTaken": "该邮箱已被其他账号使用。",
      "nameTooLong": "内容过长（最多 255 个字符）。"
    },
    "detail": {
      "tabs": {
        "users": "用户",
        "subscriptions": "订阅",
        "packages": "可分配套餐",
        "grants": "授权",
        "traffic": "流量",
        "routing": "路由"
      },
      "back": "租户",
      "edit": "编辑租户",
      "disable": "停用租户",
      "disableTitle": "停用 {{name}}？",
      "disableBody": "该租户下所有用户都将失去访问权限。",
      "disableConsequences": ["用户无法登录或连接。", "面板内无法重新启用租户，如需恢复请联系研发。"],
      "disabled": "租户已停用",
      "saved": "租户已更新",
      "cancelSubscription": "取消订阅",
      "cancelTitle": "取消该订阅？",
      "cancelBody": "用户将立即失去访问权限，且不可撤销。",
      "cancelled": "订阅已取消",
      "noPackages": "暂无可分配给该租户的套餐。",
      "policies": "路由策略",
      "noPolicies": "该租户下没有用户路由策略。",
      "newGrant": "新建授权",
      "slugTaken": "该 URL 标识已被其他租户使用。",
      "disableOwn": "这是你自己所在的租户。停用会让你和其中所有运营人员退出登录，且无法在面板中重新启用。",
      "cancelTitleNamed": "取消 {{name}} 的订阅？",
      "cancelBodyNamed": "{{plan}} 将立即终止，用户随即失去访问权限，且不可撤销。"
    }
  },
  "opUsers": {
    "promote": "提升为租户…",
    "promoteTitle": "将 {{name}} 提升为租户？",
    "promoteBody": "将新建一个租户，并把该用户移入其中作为管理员。",
    "promoteConsequences": ["该用户会离开当前租户。", "面板内无法撤销。"],
    "promoteDone": "租户已创建",
    "setManager": "更换管理员…",
    "managerTitle": "{{name}} 的管理员",
    "managerBody": "可指定用户管理员代管，或由平台直接管理。",
    "managerNone": "平台直管",
    "managerSaved": "管理员已更新",
    "makeAdmin": "设为用户管理员",
    "revokeAdmin": "移除用户管理员",
    "roleSaved": "角色已更新",
    "viewManaged": "查看其代管的用户",
    "tenantSettings": "打开租户",
    "loadedCount": "已加载 {{count}} 位",
    "revokeTitle": "移除 {{name}} 的用户管理员身份？",
    "revokeBody": "账号保留，但将无法进入用户管理工作区。",
    "revokeConsequences": [
      "将不能再管理授权范围内的用户、套餐和订阅。",
      "需先把其代管的用户转给其他管理员。",
      "每个管理范围至少要保留一名启用的管理员。"
    ],
    "openNotFound": "未找到该用户",
    "openNotFoundBody": "该用户可能不存在，或不符合当前筛选条件。",
    "managerLabel": "管理员",
    "promoteNameRequired": "请输入租户名称。",
    "promoteOtherTenant": "只能提升你所在租户内的用户。",
    "grantAdminTitle": "将 {{name}} 设为用户管理员？",
    "grantAdminBody": "他们将获得授权范围内的用户管理权限。",
    "grantAdminConsequences": [
      "可在授权范围内创建和管理用户、套餐与订阅。",
      "可查看授权范围内的用量与流量。"
    ],
    "managerInactive": "已停用，请选择启用中的管理员",
    "openNotLoaded": "尚未找到该用户",
    "openNotLoadedBody": "已加载的页面中没有该用户。请加载更多，或按邮箱搜索。"
  },
  "opPackages": {
    "title": "套餐",
    "new": "新建套餐",
    "empty": "还没有套餐",
    "emptyBody": "基于节点组或外部订阅创建套餐，然后发布。",
    "cycle": {
      "monthly": "每月",
      "quarterly": "每季",
      "yearly": "每年"
    },
    "perCycle": "{{quota}} / {{cycle}}",
    "editor": {
      "createTitle": "新建套餐",
      "editTitle": "编辑套餐",
      "steps": ["基本信息", "来源", "确认"],
      "stepsEdit": ["基本信息", "来源", "节点名称", "确认"],
      "name": "名称",
      "description": "说明",
      "quota": "每周期流量",
      "cycle": "重置周期",
      "resetEnabled": "允许自助重置用量",
      "managed": "托管节点组",
      "external": "外部订阅",
      "directWarning": "外部节点将直接分发，不经过托管安装与健康检查。",
      "sourcesRequired": "至少选择一个节点组或外部订阅。",
      "noGroups": "还没有节点组。",
      "noExternal": "还没有外部订阅。",
      "saved": "套餐已保存",
      "created": "套餐已创建为草稿",
      "conflictTitle": "该套餐已被他人修改",
      "conflictBody": "你的修改仍保留但尚未保存。载入最新版本后再重新编辑。",
      "conflictReload": "载入最新",
      "nodeNames": {
        "title": "节点名称",
        "defaultName": "默认名称",
        "group": "节点组",
        "override": "重写为",
        "placeholder": "保持默认名称",
        "overrideFor": "将 {{name}} 重写为",
        "clearFor": "清除 {{name}} 的重写",
        "search": "搜索节点",
        "clearAll": "全部清除",
        "renamed": "已重写 {{renamed}} / {{total}}",
        "online": "在线",
        "offline": "离线",
        "hint": "订阅会原样使用这里填写的名称，不再附加倍率标签，只有双栈视图仍会附加 |V4 或 |V6。保存后立即对现有订阅生效。",
        "externalNote": "外部订阅和外部节点保持原名称，不在此列出。",
        "duplicate": "该名称已被本套餐的其他节点占用。Clash 会拒绝名称重复的配置。",
        "regionWarning": "新名称不再匹配 Clash 的 HK / JP / US 地区分组。",
        "empty": "这些节点组里没有托管节点。",
        "noMatches": "没有匹配的节点。",
        "createHint": "创建后可在编辑套餐时重写节点名称。",
        "reviewLabel": "已重写节点"
      }
    },
    "publishTitle": "发布 {{name}}？",
    "publishBody": "发布后即可向用户分配。",
    "checks": "发布前检查",
    "checkItems": {
      "sources_present": "至少有一个来源",
      "node_groups_present": "包含节点组",
      "external_subscriptions_ready": "外部订阅已同步",
      "unique_nodes": "没有重复节点",
      "credentials_ready": "可以签发凭证",
      "export_ready": "订阅导出可用",
      "direct_distribution": "使用直接分发"
    },
    "published": "套餐已发布",
    "archiveTitle": "归档 {{name}}？",
    "archiveBody": "现有订阅继续使用，但不能再分配。",
    "archived": "套餐已归档",
    "deleteTitle": "删除 {{name}}？",
    "deleteBody": "将永久删除该套餐。仍被订阅使用的套餐无法删除。",
    "deleted": "套餐已删除",
    "sources_one": "{{count}} 个来源",
    "sources_other": "{{count}} 个来源",
    "gone": "该套餐已不存在"
  },
  "opTraffic": {
    "title": "流量",
    "billingUsage": "当前账期用量",
    "billingPeriod": "账期：{{period}} · 不随图表时间范围变化",
    "openUser": "打开用户详情",
    "usageNeedsTenant": "打开用户详情查看当前账期用量。",
    "usageUnavailable": "该订阅暂时没有可用的账期用量。",
    "noSubscription": "该用户没有当前订阅。",
    "filters": {
      "tenant": "租户"
    },
    "rankings": "用量排行",
    "dimensions": {
      "tenant": "租户",
      "user": "用户",
      "node": "节点"
    },
    "clearFilter": "清除{{dimension}}筛选：{{name}}",
    "selectedUser": "所选用户",
    "selectedNode": "所选节点"
  },
  "grants": {
    "title": "授权与封禁",
    "tabs": {
      "grants": "授权",
      "denies": "封禁"
    },
    "new": "新建授权",
    "columns": {
      "node": "节点",
      "tenant": "租户",
      "mode": "撤销方式",
      "origin": "来源",
      "created": "创建时间"
    },
    "filters": {
      "tenant": "租户",
      "node": "节点",
      "revoked": "包含已撤销"
    },
    "empty": "没有授权",
    "emptyBody": "授权会根据订阅自动生成，也可以在这里手动创建。",
    "fromSubscription": "由订阅自动维护，请通过套餐或订阅调整。",
    "form": {
      "createTitle": "新建授权",
      "editTitle": "编辑授权",
      "node": "节点",
      "tenant": "租户",
      "grantedBy": "备注",
      "grantedByHint": "审批人或原因，记录在审计日志中。",
      "mode": "撤销时",
      "modes": {
        "hard": "立即切断访问。",
        "soft": "等待现有会话结束后再切断。",
        "scheduled": "到指定时间自动撤销。"
      },
      "revokeAt": "撤销时间",
      "revokeAtRequired": "请选择撤销时间。"
    },
    "saved": "授权已保存",
    "revokeTitle": "撤销该授权？",
    "revokeBody": "{{tenant}} 将按撤销方式失去 {{node}} 的访问权限。",
    "revoked": "授权已撤销",
    "deny": {
      "new": "新建封禁",
      "notice": "封禁会被保存并生效，但目前 API 无法列出已有封禁。下方只显示本次访问中在此页面创建的封禁，便于更正。",
      "empty": "本次访问尚未创建封禁",
      "emptyBody": "在安全事件期间，可封禁某租户对某节点的访问。",
      "createTitle": "新建封禁",
      "editTitle": "编辑封禁",
      "reason": "原因",
      "reasonRequired": "请说明封禁原因。",
      "startsAt": "开始",
      "endsAt": "结束",
      "windowHint": "留空表示不限。",
      "saved": "封禁已保存",
      "deleteTitle": "移除该封禁？",
      "deleteBody": "如仍有授权，{{tenant}} 将恢复对 {{node}} 的访问。",
      "deleted": "封禁已移除",
      "justNow": "本次访问创建",
      "window": "{{from}} → {{to}}",
      "open": "不限",
      "leave": "离开此页面后，你在这里创建的封禁将无法再次列出（封禁仍然生效）。仍要离开吗？",
      "endBeforeStart": "结束时间必须晚于开始时间。",
      "confirmTitle": "在 {{node}} 上封禁 {{tenant}}？",
      "confirmBody": "该租户的用户将{{window}}无法使用此节点。现有授权保留，但封禁生效期间无法连接。",
      "confirmCreate": "创建封禁",
      "windowNow": "立即",
      "windowUntilRemoved": "直到封禁被移除",
      "windowRange": "自{{from}}起，{{until}}",
      "windowUntil": "直到{{at}}",
      "removalUnconfirmed": "移除未确认：可能已经解除。请再次移除以确保生效。",
      "gone": "此封禁已不存在",
      "goneBody": "它已被移除（可能是之前一次响应丢失的移除操作）。",
      "editUnconfirmed": "修改未确认：显示的是你保存的值，可能尚未生效。再次保存是安全的（会整体替换该封禁）。"
    },
    "viewLabel": "显示",
    "schedule": {
      "action": "定时撤销…",
      "title": "定时撤销",
      "submit": "定时撤销",
      "mustBeFuture": "请选择未来的时间。",
      "confirmTitle": "确认定时撤销？",
      "confirmBody": "{{tenant}} 将于 {{when}} 失去对 {{node}} 的访问权限。",
      "saved": "已设置定时撤销",
      "alreadyRevoked": "该授权已被撤销，无需再安排。"
    },
    "revokeBodyNow": "{{tenant}} 将立即失去对 {{node}} 的访问，已连接的会话会被断开。",
    "revokeBodySoft": "{{tenant}} 现在起失去对 {{node}} 的访问，已连接的会话可自然结束（缓冲撤销）。",
    "revokesAt": "将于 {{time}} 撤销",
    "revokedAt": "已于 {{time}} 撤销",
    "alreadyRevoked": "该授权已被撤销。",
    "otherTenantAttempt": "该未完成的授权属于另一个租户。请在该租户页面或授权页面完成。"
  },
  "domains": {
    "title": "凭证域",
    "new": "新建凭证域",
    "name": "名称",
    "nameHint": "小写标识，例如 default 或 premium。",
    "description": "说明",
    "empty": "还没有凭证域",
    "emptyBody": "节点组成员通过凭证域决定用户获得哪套凭证。",
    "created": "凭证域已创建",
    "note": "凭证域创建后无法重命名或删除。",
    "nameInvalid": "只能使用小写字母、数字、- 或 _，并以字母或数字开头。"
  },
  "enroll": {
    "title": "注册令牌",
    "issue": "签发令牌",
    "expires": "过期时间",
    "expiresRequired": "请选择过期时间。",
    "node": "绑定节点",
    "issued": "令牌已签发",
    "secretTitle": "注册令牌",
    "check": "检查令牌",
    "token": "令牌",
    "verify": "校验",
    "consume": "核销",
    "consumeTitle": "核销该令牌？",
    "consumeBody": "令牌将被标记为已使用，无法再用于注册。",
    "result": "结果",
    "valid": "令牌有效",
    "consumed": "令牌已核销",
    "singleUse": "一次性",
    "multiUse": "可复用",
    "usedAt": "使用时间",
    "notUsed": "尚未使用",
    "expiresPast": "请选择一个未来的时间。",
    "usage": "使用方式",
    "rejectedExpired": "此令牌已过期，请重新签发。",
    "rejectedUsed": "此令牌已被使用，一次性令牌只能使用一次。",
    "issueUnknownTitle": "可能已签发了一个令牌",
    "issueUnknownBody": "响应丢失，因此无法显示其密钥，且此处无法列出或撤销令牌。如果已签发，它在 {{expires}} 之前一直有效。请在确认这一点后再签发新的令牌。",
    "issueUnknownAck": "我已知晓",
    "consumeUnknown": "该令牌可能已被使用",
    "consumeUnknownBody": "请求已发出，但响应丢失。再次核销会重放同一请求并显示结果。"
  },
  "ann": {
    "title": "公告",
    "new": "新建公告",
    "empty": "没有公告",
    "emptyBody": "公告会出现在用户的通知中。",
    "audience": "受众",
    "everyone": "所有人",
    "published": "{{time}}发布",
    "draft": "草稿 · {{time}}更新",
    "expires": "有效至 {{date}}",
    "form": {
      "createTitle": "新建公告",
      "editTitle": "编辑公告",
      "title": "标题",
      "body": "内容",
      "audience": "受众",
      "tenant": "租户",
      "expires": "显示至",
      "expiresHint": "可选，到期后用户将看不到。",
      "publishNow": "立即发布",
      "preview": "预览",
      "expiresPast": "该时间已过。过期的公告对所有人隐藏；请选择未来的时间或留空。"
    },
    "actions": {
      "publish": "发布",
      "republish": "重新发布",
      "archive": "归档",
      "delete": "删除",
      "edit": "编辑"
    },
    "saved": "公告已保存",
    "publishedToast": "公告已发布",
    "archived": "公告已归档",
    "deleted": "公告已删除",
    "deleteTitle": "删除“{{title}}”？",
    "deleteBody": "此操作不可撤销。",
    "archiveTitle": "归档“{{title}}”？",
    "archiveBody": "用户将看不到它，之后可以重新发布。",
    "cantDelete": "已发布的公告需先归档才能删除。",
    "publishTitle": "发布“{{title}}”？",
    "publishBodyAll": "所有用户会立即在通知中看到它。",
    "publishExpired": "该公告已过期，发布后没有人能看到。请先修改到期时间。",
    "gone": "该公告已不存在",
    "publishBodyTenantNamed": "{{tenant}} 的所有用户会立即在通知中看到它。",
    "emptyFiltered": "没有此状态的公告",
    "showAll": "显示全部"
  },
  "servers": {
    "title": "服务器",
    "new": "添加服务器",
    "empty": "还没有服务器",
    "emptyBody": "添加服务器即可获得一条用于主机的一次性安装命令。",
    "nodes_one": "{{count}} 个节点",
    "nodes_other": "{{count}} 个节点",
    "never": "从未上线",
    "seen": "{{time}}在线",
    "manifest": "配置版本 {{applied}} / {{latest}}",
    "applied": "配置已应用",
    "pendingApply": "等待应用版本 {{rev}}",
    "applyFailed": "配置应用失败",
    "state": {
      "online": "在线",
      "offline": "离线",
      "pending": "待安装",
      "draining": "排空中",
      "disabled": "已停用",
      "attention": "需关注",
      "unknown": "状态未知"
    },
    "actions": {
      "open": "打开",
      "edit": "编辑",
      "reissue": "重新签发安装命令",
      "enable": "启用",
      "disable": "停用",
      "delete": "删除服务器",
      "installCommands": "节点与安装命令"
    },
    "edit": {
      "title": "编辑服务器",
      "name": "名称",
      "status": "状态",
      "metadata": "标签",
      "metadataHint": "JSON 对象，例如 {\"region\":\"JP\"}，用于命名与筛选。",
      "metadataInvalid": "请输入有效的 JSON 对象。",
      "saved": "服务器已保存"
    },
    "wizard": {
      "title": "添加服务器",
      "steps": ["信息", "首个节点", "安装", "连接"],
      "name": "服务器名称",
      "nameHint": "例如 tokyo-01。若设置了地区、服务商或线路标签，服务器将改以这些标签显示。",
      "region": "地区标签",
      "regionHint": "可选，例如 JP 或 US-West。",
      "installTitle": "在主机上运行",
      "installBody": "以 root 身份在服务器上粘贴此命令。它只安装此节点的适配器；之后可在服务器页面添加更多节点，每个节点都有自己的安装命令。",
      "command": "安装命令",
      "token": "Agent 令牌",
      "script": "安装脚本",
      "showScript": "查看完整脚本",
      "ran": "我已运行",
      "waiting": "等待节点连接…",
      "waitingBody": "会自动更新，安装通常不到一分钟。",
      "connected": "节点已连接",
      "preflight": "预检",
      "skipWait": "稍后完成",
      "firstNode": "添加服务器的第一个节点",
      "done": "服务器已添加",
      "backToInstall": "再次显示安装命令",
      "alreadyCreatedTitle": "服务器已创建",
      "alreadyCreatedBody": "之前的一次尝试已经创建了它，但一次性安装命令无法再次显示。请关闭此窗口，在服务器菜单中重新签发安装命令。",
      "alreadyCreatedAction": "前往服务器列表",
      "addFirstNode": "添加第一个节点",
      "issuing": "正在获取安装命令…",
      "issueFailedTitle": "节点已创建，但未能获取安装命令",
      "issueRetry": "获取安装命令",
      "openServer": "打开服务器",
      "attemptKeptTitle": "之前的一次尝试可能已创建该服务器",
      "attemptKeptBody": "下方是你上次提交的信息。继续即可完成那次尝试，而不会再创建一台服务器。",
      "startNew": "创建新的服务器",
      "retryOriginal": "使用原来的信息",
      "attemptChangedBody": "当前信息与之前的尝试不同，而那次尝试可能已经创建了服务器。提交不同的信息可能会再创建一台：请使用原来的信息完成那次尝试，或明确选择创建新的服务器。"
    },
    "deleteTitle": "删除 {{name}}？",
    "deleteBody": "将删除服务器记录及分配在其上的所有节点。",
    "deleted": "服务器已删除",
    "uninstallTitle": "清理主机",
    "uninstallBody": "删除服务器不会影响机器本身。请在主机上运行以下命令，停止它运行的所有节点适配器并移除适配器文件。",
    "uninstallOneLine": "单行",
    "uninstallScript": "分步",
    "reissuedTitle": "新的安装命令",
    "saved": "服务器已保存",
    "toggled": "服务器已更新",
    "disable": {
      "title": "停用 {{name}}？",
      "body": "该服务器将在面板中停止服务。",
      "noReissue": "停用后无法重新签发安装命令，也不能再添加节点。",
      "hasNodes_one": "它上面仍有 {{count}} 个节点。请先迁移或删除节点；有节点的服务器无法停用。",
      "hasNodes_other": "它上面仍有 {{count}} 个节点。请先迁移或删除节点；有节点的服务器无法停用。",
      "reenable": "之后可随时重新启用。",
      "unknownNodes": "暂时无法检查已分配的节点。仍在运行节点的服务器不能停用，因此在节点加载完成前无法操作。",
      "manifestPending": "该服务器的最新配置尚未应用",
      "manifestPendingBody": "服务器应用最新配置之前无法停用。若它已不再上报，请改为删除。"
    },
    "uninstallFormat": "命令格式",
    "deleteUnknownCount": "分配给此服务器的所有节点都会被删除。节点数量无法加载。",
    "alreadyInState": "服务器已处于该状态，未做更改。",
    "reissueNeedsEnabled": "请先启用服务器，再签发新的安装命令。",
    "uninstallLegacy": "旧版 agent 模式安装",
    "uninstallLegacyBody": "该服务器还上报过 agent 模式安装。如果该守护进程仍在主机上，也请一并移除。",
    "nodesOnline": "{{total}} 个节点中 {{online}} 个在线",
    "uninstallCommandLabel": "清理命令",
    "uninstallLegacyLabel": "旧版 agent 模式清理命令",
    "deleteLeave": "服务器正在删除，或其主机清理命令仍在显示。现在离开将无法再次查看。仍要离开吗？",
    "uninstallUnconfirmed": "删除请求的响应丢失，且无法确认是否已删除。请先确认它已不在列表中再运行这些命令：在仍在使用的主机上运行会停止其节点。",
    "nameTooLong": "名称过长（最多 255 字节，每个中文字符计 3 字节）。",
    "deleteConsequences_other": [
      "已分配的 {{count}} 个节点会被删除。",
      "用户下次刷新时会失去这些节点。",
      "在你卸载之前，主机上的程序会继续运行。"
    ],
    "deleteConsequences_one": [
      "已分配的 {{count}} 个节点会被删除。",
      "用户下次刷新时会失去这些节点。",
      "在你卸载之前，主机上的程序会继续运行。"
    ],
    "labelsReplaceName": "设置了地区、服务商或线路标签时，服务器以这些标签显示，而不是此名称。",
    "sharedRelay": {
      "add": "添加转发入口",
      "label": "转发节点",
      "saved": "转发入口已添加",
      "sharedBackend": "共享现有后端",
      "configured": "入口已配置",
      "backend": "后端服务器",
      "group": "套餐可选节点组",
      "address": "公网 IPv4 / 域名",
      "port": "公网端口",
      "accounting": "鉴权与用量",
      "accountingBody": "使用每位用户的后端凭据和配额，流量按关联的后端节点记录。共用同一节点的入口合并计量；需要按线路区分时，应关联独立的后端节点和监听端口。"
    },
    "columns": {
      "name": "名称",
      "state": "状态",
      "address": "IPv4",
      "created": "创建时间"
    }
  },
  "serverDetail": {
    "back": "服务器",
    "tabs": {
      "overview": "概览",
      "nodes": "节点",
      "tokens": "令牌"
    },
    "status": "状态",
    "addresses": "地址",
    "version": "适配器",
    "fingerprint": "指纹",
    "installed": "安装时间",
    "lastSeen": "最后在线",
    "created": "创建时间",
    "configuration": "配置",
    "revisionApplied": "已应用版本 {{rev}}",
    "revisionPending": "已应用 {{applied}} · 待应用 {{latest}}",
    "applyError": "应用错误",
    "preflight": "预检",
    "preflightChecked": "{{time}}检查",
    "preflightNotReported": "服务器尚未上报预检结果。",
    "checks": {
      "ports": "端口可用",
      "system": "系统受支持",
      "time_sync": "时钟同步",
      "certificate": "证书可信",
      "outbound_network": "可连接面板",
      "permissions": "权限",
      "capabilities": "能力"
    },
    "nodes": {
      "new": "新建节点",
      "newDisabled": "启用此服务器后才能添加节点。",
      "empty": "此服务器上没有节点",
      "emptyBody": "创建节点即可从这台主机为用户提供服务。",
      "unassign": "从服务器移除",
      "unassignTitle": "从此服务器移除 {{name}}？",
      "unassignBody": "节点将不再从此服务器接收配置，但节点本身不会被删除。",
      "unassigned": "节点已从服务器移除",
      "move": "迁移到其他服务器…",
      "moveTitle": "迁移 {{name}}",
      "moveBody": "迁移只会在面板中重新分配节点。节点的适配器会继续在当前主机上运行，直到你将其移除；目标主机需要运行该节点的安装命令。迁移完成后会依次给出这两步操作。",
      "target": "目标服务器",
      "moved": "节点已迁移",
      "createTitle": "新建节点",
      "protocol": "协议",
      "port": "端口",
      "portHint": "留空则使用协议默认端口。",
      "nodeName": "名称",
      "nodeNameHint": "根据协议与服务器自动建议。",
      "ssMethod": "加密方式",
      "created": "节点已创建",
      "targetUnavailable": "无法接收节点（{{status}}）",
      "moveNeedsActive": "只有已启用或待安装的节点可以迁移。",
      "resumedAttempt": "上次创建此节点的请求可能已成功。使用这些值再次创建会重放该请求，不会新增第二个节点。",
      "installCommand": "安装命令",
      "attemptChanged": "之前的尝试可能已经创建了这个节点。当前值与那次不同，现在创建可能会多出一个节点。请使用原来的值完成那次尝试，或明确选择创建新节点。",
      "retryOriginal": "使用原来的值",
      "startNew": "创建新节点",
      "leaveDuringChange": "节点变更正在进行，或后续步骤仍在显示。现在离开将无法再次查看清理和安装命令。仍要离开吗？",
      "moveInstallFailed": "{{name}} 已迁移，但无法获取它在新服务器上的安装命令。现在重新获取，或稍后在该服务器的“节点”页获取。",
      "openTarget": "打开新服务器",
      "changeUnconfirmed": "无法确认对 {{name}} 的变更是否生效。离开前请再次检查：若已生效，其主机需要清理。",
      "checkAgain": "再次检查",
      "movedElsewhere": "该节点已不在迁移目标服务器上。请在其当前所在的服务器上安装。",
      "movedElsewhereBody": "可能有人同时迁移了它。其适配器仍在此主机上运行：接下来会显示清理命令。",
      "moveChecking": "响应丢失。正在确认迁移是否已生效…",
      "finishChangeFirst": "请先完成当前的节点变更",
      "targetUnconfirmed": "{{name}} 已离开此服务器，但尚未确认它已在新服务器上。请再次检查以获取其安装命令。",
      "movedElsewhereShown": "此主机的清理命令已在之前显示过。",
      "targetGone": "{{name}} 的新服务器已不存在",
      "targetGoneBody": "节点已离开此服务器，但目标服务器已被删除。其适配器仍在此主机上运行：接下来会显示清理命令。",
      "notOnTarget": "{{name}} 不在迁移目标服务器上",
      "installMovedOff": "{{name}} 已不在此服务器上。如它在其他服务器上，请在那里安装。"
    },
    "tokens": {
      "new": "新建令牌",
      "label": "标签",
      "prefix": "前缀",
      "expires": "过期",
      "lastUsed": "最后使用",
      "empty": "没有令牌",
      "rotate": "轮换",
      "revoke": "撤销",
      "delete": "删除",
      "rotateTitle": "轮换 {{name}}？",
      "rotateBody": "将签发新令牌，旧令牌在短暂宽限期内仍可用。",
      "revokeTitle": "撤销 {{name}}？",
      "revokeBody": "服务器将无法再用此令牌认证。",
      "deleteTitle": "删除 {{name}}？",
      "deleteBody": "将永久删除这个已撤销的令牌。",
      "secretTitle": "Agent 令牌",
      "createdBody": "请立即复制，之后不会再次显示。该服务器上的节点适配器可将其用作令牌。安装节点请使用“节点”标签页中该节点的安装命令。",
      "revoked": "令牌已撤销",
      "deleted": "令牌已删除",
      "unnamed": "未命名令牌",
      "rotateUnknown": "轮换可能已经生效",
      "rotateUnknownBody": "如果已生效，旧令牌已被撤销，且新令牌无法再次显示。请查看令牌列表；若旧令牌显示为已撤销，请新建令牌并更新主机配置。",
      "agentRotateUnknownBody": "如果已生效，列表中会出现一个替换令牌，其密钥无法再次显示；旧令牌在宽限期内仍然有效。请撤销该替换令牌并新建令牌，而不要再次轮换。",
      "issueUnknown": "可能已签发新令牌",
      "issueUnknownBody": "响应丢失，因此无法显示其密钥。请查看令牌列表并撤销不认识的令牌，然后重试。",
      "createdExpires": "创建于 {{created}} · {{expires}} 过期",
      "createdNoExpiry": "创建于 {{created}} · 不过期",
      "labelTooLong": "标签过长（最多 255 字节，每个中文字符计 3 字节）。"
    },
    "nodeHealth": {
      "title": "该服务器上的节点",
      "none": "还没有节点，请在“节点”标签页添加。",
      "online": "在线",
      "pending": "等待安装",
      "offline": "离线或需关注",
      "drift": "配置漂移",
      "disabled": "已停用"
    }
  },
  "nodes": {
    "title": "节点",
    "new": "新建独立节点",
    "search": "搜索名称或地址",
    "columns": {
      "node": "节点",
      "server": "服务器",
      "address": "IP",
      "health": "健康",
      "config": "配置",
      "version": "适配器",
      "seen": "最后在线"
    },
    "filters": {
      "protocol": "协议",
      "health": "健康",
      "server": "服务器",
      "drift": "配置漂移"
    },
    "health": {
      "online": "在线",
      "attention": "需关注",
      "offline": "离线",
      "pending": "未安装",
      "disabled": "已停用"
    },
    "drift": "漂移",
    "noServer": "独立",
    "empty": "还没有节点",
    "emptyBody": "可在服务器中创建节点，或创建带独立安装命令的独立节点。",
    "detail": {
      "tabs": {
        "overview": "概览",
        "tokens": "适配器令牌"
      },
      "inbounds": "入站",
      "users_one": "{{count}} 位用户",
      "users_other": "{{count}} 位用户",
      "runtime": "运行状态",
      "uptime": "运行时长",
      "connections": "连接数",
      "memory": "内存",
      "singbox": "sing-box",
      "appliedRev": "已应用版本",
      "pendingRev": "待应用版本",
      "routing": "打开路由",
      "reissue": "重新签发安装命令",
      "delete": "删除节点",
      "deleteTitle": "删除 {{name}}？",
      "deleteBody": "将从控制面删除该节点。",
      "deleteConsequences": ["仍被套餐使用或存在活跃启动会话的节点无法删除。", "需另行在主机上卸载适配器。"],
      "deleted": "节点已删除",
      "noHeartbeat": "尚未收到心跳。"
    },
    "edit": {
      "title": "编辑节点",
      "saved": "节点已保存",
      "address4": "IPv4 地址",
      "address6": "IPv6 地址",
      "transport": "传输方式",
      "portInvalid": "请输入 1 到 65535 之间的端口。",
      "addressCannotClear": "此处只能修改地址，无法清除。请填写新的地址。",
      "nameRequired": "请输入名称。",
      "address4Invalid": "请输入 IPv4 地址，例如 203.0.113.10。",
      "address6Invalid": "请输入 IPv6 地址，例如 2001:db8::1。",
      "labelsReplaceName": "显示时会加上协议前缀。设置了地区、服务商或线路标签时，节点改以这些标签显示。",
      "nameFromLabels": "该节点以地区、服务商和线路标签显示。如需改名，请修改元数据中的标签。"
    },
    "create": {
      "title": "新建独立节点",
      "submit": "创建节点",
      "maybeCreatedTitle": "“{{name}}”可能已经创建",
      "maybeCreatedBody": "响应丢失，且现在出现了一个同名的新节点。它很可能是你创建的，但无法确认；它的首个安装令牌从未显示（可能仍然有效）。请打开该节点核对信息，撤销不认识的适配器令牌，然后在那里获取安装命令。",
      "openExisting": "打开节点",
      "startNew": "改为新建另一个节点",
      "unknownTitle": "无法确定“{{name}}”是否已创建",
      "unknownBody": "上次提交没有收到响应。请先再检查一次再创建，以免出现两个节点。",
      "unknownLookupFailed": "上次提交没有收到响应，节点列表也无法读取。连接恢复后请再检查一次。",
      "checkAgain": "再检查一次",
      "unknownNotFoundYet": "暂时还查不到这个名称的节点。它可能仍在提交中，再次创建可能会产生第二个。请稍后再检查，或者有意开始一个新节点。"
    },
    "bundleTitle": "安装命令",
    "bundleBody": "在主机上运行，它会提示输入一次性适配器令牌。",
    "adapterToken": "适配器令牌",
    "adapterConfig": "适配器配置",
    "disable": {
      "title": "停用 {{name}}？",
      "body": "适配器应用此变更后，该节点立即停止接受连接。",
      "consequences": [
        "通过此节点连接的用户会被断开。",
        "订阅中仍会列出该节点，但在恢复为启用前不会承载流量。"
      ],
      "confirm": "停用节点"
    },
    "tokens": {
      "rotateBody": "将签发新令牌，旧令牌立即失效。在安装新令牌之前，节点适配器无法获取配置或上报流量。",
      "rotateExpired": "该令牌已过期，轮换只会得到一个同样已过期的令牌。请改为新建令牌。",
      "revokeBody": "该令牌会立即失效。若节点适配器正在使用它，在安装新令牌之前将无法获取配置或上报流量。"
    },
    "uninstallTitle": "在主机上清理该节点",
    "uninstallBody": "该节点的适配器实例仍在其主机上运行。请在该主机上运行以下命令停止它并移除其配置与状态，同一主机上的其他节点不受影响。",
    "bundleBodyOn": "请在 {{server}}（节点迁移到的服务器）上运行，而不是当前服务器。运行时会提示输入一次性适配器令牌。",
    "installUnknown": "可能已为 {{name}} 签发安装令牌",
    "installUnknownBody": "响应丢失，因此无法显示其密钥。重试前，请在“节点”页打开 {{name}}，撤销不认识的适配器令牌。",
    "deleteLeave": "正在确认节点删除结果，或其主机清理命令仍在显示。现在离开将无法再次查看。仍要离开吗？",
    "unseenTokenTitle": "可能存在一个从未显示过的适配器令牌",
    "unseenTokenBody": "此节点的某个请求在可能已签发令牌后丢失了响应。请撤销下方不认识的令牌；确认之前，此节点的安装命令将保持停用。",
    "unseenTokenDone": "我已检查令牌",
    "unseenTokenBlocked": "请先在“节点”页检查此节点的适配器令牌：可能已签发了一个从未显示过的令牌。",
    "unseenTokenReissueOff": "已停用重新签发：可能已签发了一个从未显示过的令牌。",
    "reviewTokens": "查看令牌",
    "unseenTokenWaitList": "需要先加载最新的令牌列表才能确认。",
    "unseenMoveBlocked": "{{name}} 已迁移，但其安装命令已暂停：可能已为它签发了一个从未显示的令牌。请先检查其适配器令牌。",
    "getInstallCommand": "获取安装命令",
    "unseenTokenListFailed": "无法加载当前的令牌列表，暂时无法确认。",
    "reloadTokens": "重新加载令牌",
    "drain": {
      "title": "排空 {{name}}？",
      "body": "保存后该节点即退出服务。",
      "consequences": [
        "其适配器将无法获取配置，之后的更改不会下发到该节点。",
        "在你将其恢复为启用前，它不会出现在用户的订阅中。"
      ],
      "confirm": "排空节点"
    },
    "openGone": "该节点已不存在"
  },
  "groups": {
    "title": "节点组",
    "external": {
      "title": "外部节点",
      "empty": "此组还没有外部节点。",
      "pick": "选择外部节点",
      "add": "加入节点组",
      "remove": "移除",
      "added": "外部节点已加入节点组",
      "removed": "外部节点已移出节点组"
    },
    "new": "新建节点组",
    "empty": "还没有节点组",
    "emptyBody": "套餐按节点组授予访问权限，先创建一个节点组。",
    "members_one": "{{count}} 个节点",
    "members_other": "{{count}} 个节点",
    "manage": "成员",
    "form": {
      "createTitle": "新建节点组",
      "editTitle": "编辑节点组",
      "name": "名称",
      "description": "说明"
    },
    "saved": "节点组已保存",
    "deleteTitle": "删除 {{name}}？",
    "deleteBody": "仍被套餐使用的节点组无法删除。",
    "deleted": "节点组已删除",
    "members": {
      "title": "{{name}} 的成员",
      "body": "每个成员都有凭证域与计费倍率。2/1 表示按 2 倍流量计费。",
      "add": "添加节点",
      "addTitle": "添加节点",
      "search": "搜索节点",
      "selectAll": "全选当前结果",
      "domain": "凭证域",
      "rate": "计费倍率",
      "addSubmit_one": "添加 {{count}} 个节点",
      "addSubmit_other": "添加 {{count}} 个节点",
      "added_one": "已添加 {{count}} 个节点",
      "added_other": "已添加 {{count}} 个节点",
      "partial": "成功 {{ok}} 个，失败 {{failed}} 个",
      "remove": "移除",
      "removed": "成员已移除",
      "updated": "成员已更新",
      "empty": "还没有成员",
      "noneAvailable": "所有节点都已在该组中。",
      "removeTitle": "从该节点组移除 {{node}}？",
      "removeBody": "所有使用 {{group}} 的套餐都将不再提供该节点。订阅用户会在下次配置同步后失去该节点。",
      "thisNode": "该节点",
      "rateInvalid": "倍率至少为 1 / 1。",
      "allFailed_one": "无法添加该节点，原因见下方。",
      "allFailed_other": "{{count}} 个节点均未添加成功，原因见下方。",
      "maybeAdded": "可能已添加（响应丢失）。",
      "relayBackend": "后端",
      "maybeAddedBody": "成员列表已刷新：现已列为成员的节点即已添加。"
    }
  },
  "routing": {
    "title": "路由",
    "counts": {
      "globalVersion": "版本 {{version}}",
      "noGlobal": "尚未发布",
      "nodesCustom": "{{count}} 个已自定义",
      "policies_one": "{{count}} 条策略",
      "policies_other": "{{count}} 条策略",
      "loading": "统计中…",
      "unavailable": "暂无法统计",
      "someUnavailable": "部分路由信息加载失败，以上统计可能不完整。",
      "rejectLists_one": "{{count}} 份列表",
      "rejectLists_other": "{{count}} 份列表",
      "nodesAccessControlled_one": "{{count}} 个节点在用",
      "nodesAccessControlled_other": "{{count}} 个节点在用"
    },
    "open": "打开",
    "rules_one": "{{count}} 条规则",
    "rules_other": "{{count}} 条规则",
    "final": "其余 → {{outbound}}",
    "preflight": {
      "run": "运行预检",
      "running": "正在检查所有目标节点…",
      "title": "预检",
      "passed": "{{total}} 个节点中 {{ready}} 个就绪",
      "failed": "无法发布：请先修复下方错误",
      "stale": "内容在上次预检后已修改，请重新预检再保存。",
      "required": "运行预检后才能发布。",
      "node": "节点",
      "revision": "版本 {{from}} → {{to}}",
      "diff": "新增 {{added}} · 删除 {{removed}}",
      "finalChanged": "兜底出站变化",
      "ruleSetChanged": "规则集变化",
      "warnings": "警告",
      "errors": "错误",
      "effective": "生效路由",
      "missingTags": "缺少出站：{{tags}}",
      "portable": "全部节点可用：{{tags}}",
      "notEligible": "非目标节点"
    },
    "global": {
      "title": "全局默认",
      "editor": "路由",
      "publish": "发布",
      "publishTitle": "发布全局路由？",
      "published": "全局路由已发布",
      "version": "版本 {{version}} · {{time}}",
      "invalid": "路由必须是带有 final 出站的 JSON 对象。",
      "leaveUnsaved": "全局路由修改尚未发布。确定离开并放弃这些修改吗？",
      "publishBody_other": "这会在 {{count}} 个节点获取下一个版本时改变其路由。",
      "publishBody_one": "这会在 {{count}} 个节点获取下一个版本时改变其路由。"
    },
    "nodes": {
      "title": "节点路由",
      "columns": {
        "node": "节点",
        "mode": "模式",
        "final": "默认出站",
        "status": "状态"
      },
      "inSync": "已同步",
      "pending": "待生效",
      "drift": "漂移",
      "noHeartbeat": "无心跳",
      "inheritedFinal": "继承",
      "globalUnavailable": "无法加载全局默认路由",
      "globalUnavailableBody": "在加载成功前，继承和叠加模式节点的兜底出站显示为不可用。",
      "settings": "设置"
    },
    "node": {
      "back": "节点路由",
      "tabs": {
        "default": "默认路由",
        "users": "用户覆盖"
      },
      "mode": "模式",
      "overlayNeedsGlobal": "需先发布全局默认才能使用叠加模式。",
      "route": "节点路由",
      "dns": "DNS",
      "save": "保存节点路由",
      "saved": "节点路由已保存",
      "status": "实时状态",
      "capability": "按用户路由",
      "capable": "支持（{{protocols}}）",
      "notCapable": "此节点的适配器不支持",
      "appliedRev": "已应用",
      "pendingRev": "待应用",
      "drift": "检测到配置漂移",
      "contract": "必需出站",
      "available": "可用出站",
      "leaveUnsaved": "路由修改尚未保存。确定离开并放弃这些修改吗？",
      "shape": {
        "notObject": "路由必须是 JSON 对象。",
        "needsFinal": "替换模式需要非空的 \"final\" 出站。",
        "noFinal": "请移除 \"final\"：叠加模式的兜底出站来自全局默认。",
        "needsRules": "叠加模式至少需要一条 \"rules\" 规则。"
      },
      "accessControl": {
        "title": "访问控制",
        "manage": "管理列表",
        "reject_from": "拒绝来源连接",
        "reject_to": "拒绝连接目标",
        "noLists": "还没有列表，可在“管理列表”中创建。",
        "missing": "已删除的列表"
      },
      "globalReference": "当前全局策略",
      "additionalRules": "节点追加规则"
    },
    "users": {
      "title": "用户路由",
      "user": "用户",
      "search": "搜索用户",
      "noPolicy": "无策略",
      "capability": "能力",
      "policies": "策略",
      "newPolicy": "新建策略",
      "noPolicies": "该用户沿用节点与全局路由。",
      "scope": "作用范围",
      "node": "节点",
      "status": "状态",
      "protocol": "协议",
      "protocolHint": "启用时用于检查节点能力。",
      "outboundTags": "出站标签",
      "outboundTagsHint": "以逗号分隔，目标节点上必须存在这些标签。",
      "route": "路由",
      "save": "保存策略",
      "saved": "策略已保存",
      "createTitle": "新建路由策略",
      "editTitle": "编辑路由策略",
      "versions": "历史",
      "version": "版本 {{version}}",
      "rollback": "恢复为草稿",
      "rollbackTitle": "恢复版本 {{version}}？",
      "rollbackBody": "将以该版本创建一条停用状态的新草稿，需预检并启用后才会生效。",
      "rolledBack": "已恢复为停用草稿",
      "delete": "删除策略",
      "deleteTitle": "删除该策略？",
      "deleteBody": "该用户将回退到节点与全局路由。",
      "deleted": "策略已删除",
      "enable": "启用",
      "disable": "停用",
      "trace": "路由轨迹",
      "unsupported": "按用户路由仅支持 Hysteria2 与 AnyTLS 节点，且适配器需上报 user-routing.v1。",
      "inherited": "继承 · 全部节点",
      "versionsTruncated": "仅显示最近 {{count}} 个版本。",
      "enableBlocked": "预检未通过，策略保持停用",
      "enableBlockedBody": "请在编辑器中检查并运行预检后再启用。",
      "disableTitle": "停用此策略？",
      "disableBodyAll": "{{user}} 将立即在所有节点上恢复为节点默认路由。",
      "disableBodyNode": "{{user}} 将立即在 {{node}} 上恢复为默认路由。",
      "outboundTagsPlaceholder": "proxy, direct",
      "alreadyInState": "已是该状态",
      "rollbackTakesOffline": "该策略正在生效。恢复的版本默认停用，在重新启用前，其路由将在所有节点上停止生效。",
      "nodeNotCapable": "{{protocol}} · 不支持按用户路由",
      "deleteBodyAll": "将删除 {{user}} 在所有节点上的策略；该用户将回退到节点与全局路由。",
      "deleteBodyNode": "将删除 {{user}} 在 {{node}} 上的策略；该节点上将回退到其默认路由与全局路由。",
      "routeNeedsRules": "请至少添加一条规则或设置最终出站：空路由无法保存。",
      "gone": "该策略已不存在"
    },
    "trace": {
      "match": "当",
      "any": "任意流量",
      "then": "则",
      "reject": "拒绝",
      "direct": "直连",
      "route": "发送到 {{outbound}}",
      "ruleSet": "规则集 {{tags}}",
      "privateIp": "私有 IP",
      "invalidShape": "无法预览该路由：rules 必须是规则对象列表，final、action 和 outbound 必须是文本。",
      "actions": {
        "route": "路由",
        "reject": "拒绝",
        "hijack_dns": "本地应答 DNS",
        "sniff": "探测协议",
        "resolve": "解析域名",
        "route_options": "设置路由选项",
        "bypass": "绕过",
        "unknown": "其他动作 {{action}}"
      },
      "notPrivateIp": "公网 IP",
      "fields": {
        "domain": "域名",
        "domain_suffix": "域名后缀",
        "domain_keyword": "域名关键词",
        "domain_regex": "域名正则",
        "ip_cidr": "IP 段",
        "source_ip_cidr": "来源 IP 段",
        "port": "端口",
        "port_range": "端口范围",
        "source_port": "来源端口",
        "source_port_range": "来源端口范围",
        "protocol": "协议",
        "network": "网络",
        "clash_mode": "Clash 模式",
        "override_address": "覆盖地址",
        "override_port": "覆盖端口",
        "network_strategy": "网络策略",
        "fallback_delay": "回退延迟",
        "udp_disable_domain_unmapping": "关闭 UDP 域名反映射",
        "udp_connect": "UDP 连接",
        "udp_timeout": "UDP 超时",
        "tls_fragment": "TLS 分片",
        "tls_fragment_fallback_delay": "TLS 分片回退延迟",
        "tls_record_fragment": "TLS 记录分片",
        "tls_spoof": "TLS 伪装",
        "tls_spoof_method": "TLS 伪装方式",
        "method": "方式",
        "no_drop": "不丢弃",
        "sniffer": "嗅探器",
        "timeout": "超时",
        "server": "服务器",
        "strategy": "策略",
        "disable_cache": "关闭缓存",
        "disable_optimistic_cache": "关闭乐观缓存",
        "rewrite_ttl": "改写 TTL",
        "client_subnet": "客户端子网",
        "remove_client_subnet": "移除客户端子网"
      }
    },
    "rejectLists": {
      "title": "拒绝 CIDR 列表",
      "new": "新建列表",
      "empty": "还没有列表",
      "emptyBody": "先创建地址列表，再到节点的路由页面中选择它。",
      "name": "名称",
      "description": "说明",
      "cidrs": "地址",
      "cidrsHint": "每行一个 IPv4 或 IPv6 前缀或地址（{{count}} / {{max}}）。保存后会自动规范化并去重。",
      "invalidLines_one": "{{count}} 行不是有效的地址或前缀：{{lines}}",
      "invalidLines_other": "{{count}} 行不是有效的地址或前缀：{{lines}}",
      "tooMany": "每份列表最多 {{max}} 条。",
      "tooLong": "内容过长。",
      "entries_one": "{{count}} 条",
      "entries_other": "{{count}} 条",
      "usedBy_one": "{{count}} 个节点在用",
      "usedBy_other": "{{count}} 个节点在用",
      "usedByNodes": "使用中：{{nodes}}。保存后这些节点会获得新的配置修订。",
      "unused": "还没有节点使用这份列表。",
      "updated": "更新于 {{when}}",
      "select": "选择一份列表进行编辑。",
      "created": "列表已创建",
      "saved": "已保存版本 {{version}}",
      "deleted": "已删除 {{name}}",
      "deleteTitle": "删除 {{name}}？",
      "deleteBody": "列表将被永久删除。",
      "deleteConsequence": "仍被节点选用的列表无法删除，请先在这些节点上取消选择。",
      "leaveUnsaved": "这份列表有未保存的修改。离开页面并放弃修改？",
      "discardDraft": "对这份列表的修改尚未保存。",
      "builtin": {
        "name": "所有节点 IP",
        "badge": "内置",
        "count_one": "当前 {{count}} 个地址",
        "count_other": "当前 {{count}} 个地址",
        "usedByNodes": "使用中：{{nodes}}。"
      }
    },
    "tabs": {
      "global": "全局策略",
      "users": "用户策略",
      "nodes": "节点默认策略",
      "access-control": "访问控制"
    },
    "binding": {
      "title": "从规则集添加规则",
      "ruleSet": "规则集",
      "action": "匹配后操作",
      "selectRuleSet": "选择规则集标签…",
      "selectAction": "选择处理方式…",
      "reject": "拒绝流量",
      "add": "添加规则",
      "remove": "移除 {{tag}} 规则",
      "latest": "自动跟随最新资源",
      "empty": "暂无可用规则集"
    }
  },
  "resources": {
    "title": "外部资源",
    "tabs": {
      "outbound": "出站",
      "rule_set": "规则集",
      "subscriptions": "外部订阅",
      "nodes": "外部节点"
    },
    "nodes": {
      "new": "新建外部节点",
      "edit": "编辑外部节点",
      "empty": "没有外部节点",
      "emptyBody": "添加节点链接后，可在节点组中选择它。",
      "uri": "节点链接",
      "uriHint": "支持外部订阅已支持的分享链接格式。保存后不再显示原始链接。",
      "uriKeep": "留空则保留当前链接。",
      "name": "名称",
      "server": "服务器",
      "protocol": "协议",
      "status": "状态",
      "enabled": "启用",
      "disabled": "停用",
      "saved": "外部节点已保存",
      "deleted": "外部节点已删除",
      "deleteTitle": "删除 {{name}}？",
      "deleteBody": "仍被节点组或用户订阅引用时无法删除。请先从节点组移除并刷新相关订阅。"
    },
    "new": "新建资源",
    "newOutbound": "新建出站",
    "newRuleSet": "新建规则集",
    "empty": "这里还没有内容",
    "emptyBody": "资源带版本，路由策略可以固定引用某个版本。",
    "select": "选择一个资源以查看和编辑。",
    "name": "名称",
    "tags": "标签",
    "tagsHint": "以逗号分隔。",
    "status": "状态",
    "definition": "定义",
    "saveVersion": "保存为新版本",
    "created": "资源已创建",
    "savedVersion": "已保存版本 {{version}}",
    "version": "版本 {{version}}",
    "versions": "版本",
    "filters": {
      "status": "状态"
    },
    "ext": {
      "new": "新建外部订阅",
      "empty": "没有外部订阅",
      "emptyBody": "从第三方订阅链接导入节点，并通过套餐分发。",
      "createTitle": "新建外部订阅",
      "editTitle": "编辑外部订阅",
      "name": "名称",
      "url": "订阅链接",
      "urlHint": "加密保存，之后不再显示。",
      "urlKeep": "留空则沿用当前链接（{{host}}）。",
      "format": "格式",
      "formats": {
        "auto": "自动识别",
        "uri": "URI 列表",
        "clash": "Clash",
        "surge": "Surge"
      },
      "filterMode": "节点过滤",
      "filterModes": {
        "include": "仅保留",
        "exclude": "排除"
      },
      "keywords": "关键词",
      "keywordsHint": "以逗号分隔，留空则全部导入。",
      "prefix": "名称前缀",
      "interval": "同步间隔",
      "intervalMinutes": "{{count}} 分钟",
      "enabled": "自动同步",
      "syncNow": "立即同步",
      "synced": "已开始同步",
      "nodes": "已导入节点",
      "noNodes": "尚未导入节点。",
      "lastSync": "上次同步",
      "nextSync": "下次同步",
      "never": "从未",
      "saved": "外部订阅已保存",
      "deleteTitle": "删除 {{name}}？",
      "deleteBody": "已导入的节点会被移除，使用它的套餐将失去这些节点。",
      "deleted": "外部订阅已删除",
      "server": "服务器",
      "nodesTruncated": "显示 {{total}} 个节点中的 {{shown}} 个。",
      "intervalInvalid": "请输入 1 到 10080（7 天）之间的整数分钟。",
      "keywordsInvalid": "最多 50 个关键词，每个不超过 80 字节（约 26 个汉字）。",
      "tooLong": "太长：请控制在 120 字节以内（约 40 个汉字）。",
      "urlRejected": "服务器拒绝了该地址。请使用不含凭据的公网 http(s) 地址。",
      "urlProblem": {
        "tooLong": "地址过长（最多 4096 字节）。",
        "invalid": "请输入完整的 http:// 或 https:// 地址。",
        "credentials": "请去掉主机前的用户名或密码（令牌请放在路径或查询参数中）。",
        "private": "这是本地或内网地址，请使用公网地址。",
        "hostTooLong": "主机名过长（最多 255 字节）。"
      }
    },
    "versionsTruncated": "仅显示最近 {{count}} 个版本。",
    "discardDraft": "此资源有未保存的修改。确定放弃吗？",
    "leaveUnsaved": "资源修改尚未保存。确定离开并放弃这些修改吗？",
    "goneFromView": "已不在此列表中",
    "goneFromViewBody": "它的状态已改变（例如被他人归档），不再符合当前筛选条件。你的草稿已保留，保存仍会更新该资源。",
    "definitionEmpty": "请至少添加一项：接口不接受空定义。",
    "definitionShape": "请使用 JSON 对象，或由对象组成的列表。"
  },
  "auditPage": {
    "title": "审计日志",
    "filters": {
      "action": "操作",
      "resource": "对象",
      "outcome": "结果",
      "system": "显示系统事件"
    },
    "actionPlaceholder": "任意操作",
    "empty": "没有匹配的事件",
    "emptyBody": "试试其他筛选条件。",
    "columns": {
      "time": "时间",
      "event": "事件",
      "resource": "对象",
      "actor": "操作者",
      "ip": "IP",
      "outcome": "结果"
    },
    "detail": {
      "title": "事件详情",
      "resource": "对象",
      "actor": "操作者",
      "outcome": "结果",
      "ip": "IP 地址",
      "requestId": "请求 ID",
      "changes": "变更",
      "snapshot": "当时的对象",
      "context": "更多信息",
      "none": "没有记录其他信息。",
      "raw": "原始记录",
      "field": "字段",
      "before": "修改前",
      "after": "修改后",
      "auditId": "记录 ID",
      "action": "操作代码"
    },
    "emptySystemHidden": "目前只有系统记录",
    "emptySystemHiddenBody": "例行系统记录已隐藏。可以显示它们，或加载更多查看更早的记录。",
    "showSystem": "显示系统记录",
    "emptyNone": "暂无活动",
    "emptyNoneBody": "在控制台中执行的操作会显示在这里。"
  }
}
